var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DataLocationStorageType, AuthenticationType, ColumnMultilineKey, parameterType } from "./module/views/DataSourceCreate/models/DataSourceDataCommon.js";
import { notDeleteKey } from "./module/views/DataSourceDetail/ducks/DataSourceDetailConstants.js";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import _ from "lodash";
import { DataLocationDataType, ADLSGen2Location, AzureBlobLocation, CosmosDataLocation, MTLocation } from "./module/constants/DataSource.DataLocation.constants.js";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useState, useRef, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { StepContainer, StepLayouts } from "@ane/ui-components/lib/components/StepContainer";
import { TextField, DropdownField, TagPickerField as TagPickerField$1, CheckboxField as CheckboxField$1 } from "@ane/ui-components/lib/components/FormikFormFields";
import { TagPickerField } from "@ane/ui-components/lib/components/FormikFormFields/TagPickerField";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { isClassicWorkspaceById } from "@ane/exp-data/lib/utils/ManagementGroup";
import { showStudioExperience } from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.utils";
import { FormHeading } from "@ane/ui-components/lib/components/FormHeading";
import { FormSection } from "@ane/ui-components/lib/components/FormSection";
import { LoadPickSubscribersField } from "@ane/exp-ux/lib/components/Subscribers/LoadPickSubscribersField";
import { ENTITY_TYPES } from "@ane/exp-data/lib/models/SubscriberModels";
import { convertSubscribersV2, convertSubscribers } from "@ane/exp-ux/lib/components/Subscribers/Subscriber.utils";
import { requestPending, requestCompleted } from "@ane/core/lib/models/IAsyncWrapper/IAsyncWrapper.utils";
import { NOTIFICATION_CATEGORY } from "@ane/exp-data/lib/constants/NotificationSettingConstants";
import { DataSourceTypeOptions, DataSourceTypes, DataLocationComponentConstants } from "./module/constants/DataSource.constants.js";
import { DropdownField as DropdownField$1 } from "@ane/ui-components/lib/components/FormikFormFields/DropdownField";
import { TextField as TextField$1 } from "@ane/ui-components/lib/components/TextField";
import { LocationKeyDetailLabel } from "./module/views/DataSourceDetail/components/DataSourceLocation/DataSourceLocation.js";
import { getAAStreamLocationPrefixFields, getAAStreamExpiryDaysField } from "./module/views/DataSourceCreate/components/DataLocationInfo/DataLocationFieldConfig.js";
import { loadServicePrincipalNameListEpicReducer } from "./module/views/DataSourceCreate/ducks/ServicePrincipalList.ducks.js";
import { loadManagedIdentityNameListEpicReducer } from "./module/views/DataSourceCreate/ducks/ManagedIdentityList.ducks.js";
import MessageBar from "@ane/ui-components/lib/components/MessageBar/MessageBar";
import { MessageBarType } from "@ane/ui-components/lib/components/MessageBar/MessageBar.types";
import FormActions from "@ane/ui-components/lib/components/FormActions/FormActions";
import { PrimaryButton } from "@ane/ui-components/lib/components/Button/PrimaryButton";
import { DefaultButton } from "@ane/ui-components/lib/components/Button/DefaultButton";
import Dialog from "@ane/ui-components/lib/components/Dialog/Dialog";
import { ButtonDialogType } from "@ane/ui-components/lib/components/Dialog/ButtonDialog.types";
import { Dropdown } from "@ane/ui-components/lib/components/Dropdown";
import { DetailsListWithCommandBar } from "@ane/ui-components/lib/components/DetailsList/DetailsListWithCommandBar";
import { Selection, SelectionMode, TextField as TextField$2, Accordion, Stack, IconButton } from "@ane/ui-components";
import { ExternalLink } from "@ane/ui-components/lib/components/ExternalLink";
import { CheckboxField } from "@ane/ui-components/lib/components/FormikFormFields/CheckboxField";
import { loadDataSourceFlightFormatsEpicReducer } from "./module/views/DataSourceCreate/ducks/DataSourceFlightFormats.ducks.js";
import { SpecialColumnsField } from "./module/views/DataSourceCreate/components/SpecialColumns/SpecialColumnsField.js";
import SpecialColumnsDropdown from "./module/views/DataSourceCreate/components/SpecialColumns/SpecialColumnsDropdown.js";
import FormHeading$1 from "@ane/ui-components/lib/components/FormHeading/FormHeading";
import FormSection$1 from "@ane/ui-components/lib/components/FormSection/FormSection";
import { StepContainer as StepContainer$1 } from "@ane/ui-components/lib/components/Layout/StepContainer/StepContainer";
import DataSourceResource from "./module/DataSource.resource.js";
import Logger from "@ane/core/lib/services/logging/Logger";
import { LearnMoreLink } from "@ane/ui-components/lib/components/Link/LearnMoreLink";
import { ChoiceGroupField } from "@ane/ui-components/lib/components/FormikFormFields/ChoiceGroupField";
const mapStateToProps$3 = (state) => {
  var _a, _b, _c;
  return {
    isStudio: showStudioExperience(state.workspace_data.workspace.data),
    workspaceId: (_b = (_a = state.currentUserDetails.userAffinity) == null ? void 0 : _a.data) == null ? void 0 : _b.workspaceId,
    isMsftWorkspace: (_c = state.workspace_data.workspace.data) == null ? void 0 : _c.IsMsftWorkspace,
    subscribersAsync: state.subscribers.items,
    subscribersAsyncV2: state.subscribersV2.items
  };
};
const mapDispatchToProps$3 = {};
class BasicInfoComponent extends React.Component {
  componentDidUpdate(preProps) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
    if (EnvironmentService.enableUnifiedAPIOfSubscribeMode()) {
      if (requestPending((_a = preProps.subscribersAsyncV2) == null ? void 0 : _a.status) && requestCompleted((_b = this.props.subscribersAsyncV2) == null ? void 0 : _b.status)) {
        let subscribers = !!((_e = (_d = (_c = this.props.subscribersAsyncV2) == null ? void 0 : _c.data) == null ? void 0 : _d.value) == null ? void 0 : _e.length) ? (_g = (_f = this.props.subscribersAsyncV2) == null ? void 0 : _f.data) == null ? void 0 : _g.value[0].subscribers : [];
        this.props.formikProps.initialValues.subscribers = convertSubscribersV2(subscribers);
      }
    } else {
      if (requestPending((_h = preProps.subscribersAsync) == null ? void 0 : _h.status) && requestCompleted((_i = this.props.subscribersAsync) == null ? void 0 : _i.status)) {
        this.props.formikProps.initialValues.subscribers = convertSubscribers((_k = (_j = this.props.subscribersAsync) == null ? void 0 : _j.data) == null ? void 0 : _k.subscribers);
      }
    }
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    let shouldResetSubscriberList = false;
    if (EnvironmentService.enableUnifiedAPIOfSubscribeMode()) {
      let subscribers = !!((_c = (_b = (_a = this.props.subscribersAsyncV2) == null ? void 0 : _a.data) == null ? void 0 : _b.value) == null ? void 0 : _c.length) ? (_e = (_d = this.props.subscribersAsyncV2) == null ? void 0 : _d.data) == null ? void 0 : _e.value[0].subscribers : [];
      if (_.isEqual(this.props.formikProps.values.subscribers, convertSubscribersV2(subscribers))) {
        shouldResetSubscriberList = true;
      }
    } else {
      if (_.isEqual(this.props.formikProps.values.subscribers, convertSubscribers((_g = (_f = this.props.subscribersAsync) == null ? void 0 : _f.data) == null ? void 0 : _g.subscribers))) {
        shouldResetSubscriberList = true;
      }
    }
    return /* @__PURE__ */ jsxs(StepContainer, { className: "create-basic-info-tab", children: [
      !this.props.isUpdateDataSource && /* @__PURE__ */ jsx(FormHeading, { pageTitle: CreateStepTitle.Basic, children: "This is where you enter basic information about your data source." }),
      /* @__PURE__ */ jsxs(FormSection, { children: [
        /* @__PURE__ */ jsx(
          TextField,
          {
            name: `name`,
            innerTextFieldProps: {
              label: "Data source name",
              onGetErrorMessage: (value) => {
                return this.props.formikProps.touched.name ? genErrorMessageDataSourceName(value) : "";
              },
              maxLength: 100,
              disabled: !this.props.isReadOnly && !!this.props.isUpdateDataSource,
              isReadOnly: !!this.props.isReadOnly,
              required: true,
              ariaLabel: "Please enter data source name",
              description: getPlaceHolder(dataSourceCreateComponentsName.basicinfo, "data source name")
            }
          }
        ),
        EnvironmentService.enableSampleDataSource() && /* @__PURE__ */ jsx(
          DropdownField,
          {
            label: "Data source use type",
            name: `dataSourceType`,
            ariaLabel: "Data source use type",
            labelProps: {
              iconProps: {
                calloutProps: {
                  content: 'Please provide a data source use type, "Main" for normal scenario, "Sample" for quick metric preview.'
                }
              }
            },
            options: DataSourceTypeOptions,
            selectedKey: (_i = (_h = this.props.formikProps) == null ? void 0 : _h.values) == null ? void 0 : _i.dataSourceType,
            required: true,
            isReadOnly: !!this.props.isReadOnly,
            disabled: !!this.props.isReadOnly || !!this.props.isUpdateDataSource,
            defaultSelectedKey: DataSourceTypes.Main
          }
        ),
        /* @__PURE__ */ jsx(
          TagPickerField,
          {
            name: `owners`,
            label: "Data source contacts",
            showSuggestions: false,
            placeholder: getPlaceHolder(dataSourceCreateComponentsName.basicinfo, "Owners"),
            required: true,
            tagPickerProps: {
              ariaLabel: "Owners list",
              removeButtonAriaLabel: "Owners List remove",
              allowNewItems: true,
              isReadOnly: !!this.props.isReadOnly
            }
          }
        ),
        /* @__PURE__ */ jsx(
          LoadPickSubscribersField,
          {
            name: "subscribers",
            required: false,
            isUpdateEntity: !!this.props.isUpdateDataSource,
            subscribers: this.props.formikProps.values.subscribers,
            workspaceId: this.props.workspaceId,
            entityType: ENTITY_TYPES.DATASOURCE,
            entityExternalId: this.props.formikProps.values.name,
            isReadOnly: !!this.props.isReadOnly,
            shouldReset: shouldResetSubscriberList,
            notificationCategory: NOTIFICATION_CATEGORY.DataSourceNotifications
          }
        )
      ] })
    ] });
  }
}
const BasicInfoComponent$1 = connect(mapStateToProps$3, mapDispatchToProps$3)(BasicInfoComponent);
function DataLocationAuthtencationFileds(props) {
  var _a, _b;
  const { isCreate } = props;
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [spNewValue, setSPNewValue] = useState("");
  const workspaceId = useSelector((state) => {
    var _a2, _b2;
    return ((_b2 = (_a2 = state.currentUserDetails.userAffinity) == null ? void 0 : _a2.data) == null ? void 0 : _b2.workspaceId) || "";
  });
  const servicePrincipalList = useSelector((state) => state.dataSourceManagementModule.servicePrincipalList.res);
  const originalSP = useSelector(
    (state) => {
      var _a2, _b2, _c, _d;
      return (_d = (_c = (_b2 = (_a2 = state.dataSourceManagementModule.dataSource) == null ? void 0 : _a2.items) == null ? void 0 : _b2.data) == null ? void 0 : _c.AuthenticationId) != null ? _d : "";
    }
  );
  const managedIdentityList = useSelector((state) => {
    var _a2;
    return (_a2 = state.dataSourceManagementModule.managedIdentityList) == null ? void 0 : _a2.res;
  });
  const _generateAuthenticationTypeDownField = (storageType) => {
    if (storageType === DataLocationStorageType.ADLSGen2 || storageType === DataLocationStorageType.AzureBlob || storageType === DataLocationStorageType.ADLSGen2CosmosView || storageType === DataLocationStorageType.Cosmos) {
      return /* @__PURE__ */ jsx(
        DropdownField$1,
        {
          name: "authenticationType",
          required: true,
          label: "Authentication type",
          placeholder: "Please select your authentication type",
          ariaLabel: "Authentication type",
          options: _getAuthenticationTypeOptions(storageType),
          isReadOnly: props.isMIReadOnly,
          defaultSelectedKey: _getAuthenticationTypeDefaultValue(storageType),
          onChange: (ev, option) => {
            var _a2;
            if (!option) {
              return;
            } else {
              (_a2 = props.formikProps) == null ? void 0 : _a2.setFieldValue("authenticationType", option.key.toString(), true);
            }
          }
        }
      );
    }
  };
  const _getAuthenticationTypeOptions = (storageType) => {
    let options = [];
    if (storageType === DataLocationStorageType.ADLSGen2) {
      options = [
        {
          key: AuthenticationType.ServicePrincipal,
          text: AuthenticationType.ServicePrincipal
        },
        { key: AuthenticationType.Secret, text: AuthenticationType.Secret }
      ];
    } else if (storageType === DataLocationStorageType.AzureBlob) {
      options = [
        {
          key: AuthenticationType.Legacy,
          text: AuthenticationType.Legacy
        }
      ];
    } else if (storageType === DataLocationStorageType.ADLSGen2CosmosView) {
      options = [
        {
          key: AuthenticationType.ServicePrincipal,
          text: AuthenticationType.ServicePrincipal
        }
      ];
    } else if (storageType === DataLocationStorageType.Cosmos) {
      options = [
        {
          key: AuthenticationType.ServicePrincipal,
          text: AuthenticationType.ServicePrincipal
        },
        {
          key: AuthenticationType.Legacy,
          text: AuthenticationType.Legacy
        }
      ];
    }
    if (showMSIOption(workspaceId)) {
      options = [
        {
          key: AuthenticationType.ManagedIdentity,
          text: AuthenticationType.ManagedIdentity
        },
        ...options
      ];
    }
    return options;
  };
  const _getAuthenticationTypeDefaultValue = (storageType) => {
    if (showMSIOption(workspaceId)) {
      if (storageType === DataLocationStorageType.ADLSGen2) {
        return props.formikProps.values.managedIdentityId !== "" && props.formikProps.values.managedIdentityId !== null ? AuthenticationType.ManagedIdentity : props.formikProps.values.authenticationId !== "" && props.formikProps.values.authenticationId !== null ? AuthenticationType.ServicePrincipal : AuthenticationType.Secret;
      } else if (storageType === DataLocationStorageType.AzureBlob) {
        return props.formikProps.values.managedIdentityId !== "" && props.formikProps.values.managedIdentityId !== null ? AuthenticationType.ManagedIdentity : AuthenticationType.Legacy;
      } else if (storageType === DataLocationStorageType.ADLSGen2CosmosView) {
        return props.formikProps.values.managedIdentityId !== "" && props.formikProps.values.managedIdentityId !== null ? AuthenticationType.ManagedIdentity : AuthenticationType.ServicePrincipal;
      } else if (storageType === DataLocationStorageType.Cosmos) {
        return props.formikProps.values.managedIdentityId !== "" && props.formikProps.values.managedIdentityId !== null ? AuthenticationType.ManagedIdentity : props.formikProps.values.authenticationId !== "" && props.formikProps.values.authenticationId !== null ? AuthenticationType.ServicePrincipal : AuthenticationType.Legacy;
      }
    } else {
      if (storageType === DataLocationStorageType.ADLSGen2) {
        return props.formikProps.values.authenticationId !== "" && props.formikProps.values.authenticationId !== null ? AuthenticationType.ServicePrincipal : AuthenticationType.Secret;
      } else if (storageType === DataLocationStorageType.AzureBlob) {
        return AuthenticationType.Legacy;
      } else if (storageType === DataLocationStorageType.ADLSGen2CosmosView) {
        return AuthenticationType.ServicePrincipal;
      } else if (storageType === DataLocationStorageType.Cosmos) {
        return props.formikProps.values.authenticationId !== "" && props.formikProps.values.authenticationId !== null ? AuthenticationType.ServicePrincipal : AuthenticationType.Legacy;
      }
    }
  };
  const _generateAuthenticationFields = () => {
    var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba;
    const dataLocationComponentList = [];
    if (((_b2 = (_a2 = props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.storageType) === StorageType.ADLSGen2) {
      if (!!((_d = (_c = props.formikProps) == null ? void 0 : _c.values) == null ? void 0 : _d.authenticationType)) {
        if (showMSIOption(workspaceId) && ((_f = (_e = props.formikProps) == null ? void 0 : _e.values) == null ? void 0 : _f.authenticationType) === AuthenticationType.ManagedIdentity) {
          dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
        } else if (((_h = (_g = props.formikProps) == null ? void 0 : _g.values) == null ? void 0 : _h.authenticationType) === AuthenticationType.ServicePrincipal) {
          dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
        } else {
          dataLocationComponentList.push(_getCommonTextField("Url"));
          dataLocationComponentList.push(_getCommonTextField("SecretName"));
        }
      } else {
        if (showMSIOption(workspaceId) && ((_j = (_i = props.formikProps) == null ? void 0 : _i.values) == null ? void 0 : _j.managedIdentityId) !== "" && ((_l = (_k = props.formikProps) == null ? void 0 : _k.values) == null ? void 0 : _l.managedIdentityId) !== null) {
          dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
        } else if (((_n = (_m = props.formikProps) == null ? void 0 : _m.values) == null ? void 0 : _n.authenticationId) !== "" && ((_p = (_o = props.formikProps) == null ? void 0 : _o.values) == null ? void 0 : _p.authenticationId) !== null) {
          dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
        } else {
          dataLocationComponentList.push(_getCommonTextField("Url"));
          dataLocationComponentList.push(_getCommonTextField("SecretName"));
        }
      }
      return dataLocationComponentList;
    } else if (((_r = (_q = props.formikProps) == null ? void 0 : _q.values) == null ? void 0 : _r.storageType) === StorageType.AzureBlob) {
      if (!!((_t = (_s = props.formikProps) == null ? void 0 : _s.values) == null ? void 0 : _t.authenticationType)) {
        if (showMSIOption(workspaceId) && ((_v = (_u = props.formikProps) == null ? void 0 : _u.values) == null ? void 0 : _v.authenticationType) === AuthenticationType.ManagedIdentity) {
          dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
        }
      } else {
        if (showMSIOption(workspaceId) && ((_x = (_w = props.formikProps) == null ? void 0 : _w.values) == null ? void 0 : _x.managedIdentityId) !== "" && ((_z = (_y = props.formikProps) == null ? void 0 : _y.values) == null ? void 0 : _z.managedIdentityId) !== null) {
          dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
        }
      }
      return dataLocationComponentList;
    } else if (((_B = (_A = props.formikProps) == null ? void 0 : _A.values) == null ? void 0 : _B.storageType) === StorageType.ADLSGen2CosmosView) {
      if (!!((_D = (_C = props.formikProps) == null ? void 0 : _C.values) == null ? void 0 : _D.authenticationType)) {
        if (showMSIOption(workspaceId) && ((_F = (_E = props.formikProps) == null ? void 0 : _E.values) == null ? void 0 : _F.authenticationType) === AuthenticationType.ManagedIdentity) {
          dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
        } else if (((_H = (_G = props.formikProps) == null ? void 0 : _G.values) == null ? void 0 : _H.authenticationType) === AuthenticationType.ServicePrincipal) {
          dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
        }
      } else {
        if (showMSIOption(workspaceId) && ((_J = (_I = props.formikProps) == null ? void 0 : _I.values) == null ? void 0 : _J.managedIdentityId) !== "" && ((_L = (_K = props.formikProps) == null ? void 0 : _K.values) == null ? void 0 : _L.managedIdentityId) !== null) {
          dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
        } else if (((_N = (_M = props.formikProps) == null ? void 0 : _M.values) == null ? void 0 : _N.authenticationId) !== "" && ((_P = (_O = props.formikProps) == null ? void 0 : _O.values) == null ? void 0 : _P.authenticationId) !== null) {
          dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
        }
      }
      return dataLocationComponentList;
    } else if (((_R = (_Q = props.formikProps) == null ? void 0 : _Q.values) == null ? void 0 : _R.storageType) === StorageType.Cosmos) {
      if (!!((_T = (_S = props.formikProps) == null ? void 0 : _S.values) == null ? void 0 : _T.authenticationType)) {
        if (showMSIOption(workspaceId) && ((_V = (_U = props.formikProps) == null ? void 0 : _U.values) == null ? void 0 : _V.authenticationType) === AuthenticationType.ManagedIdentity) {
          dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
        } else if (((_X = (_W = props.formikProps) == null ? void 0 : _W.values) == null ? void 0 : _X.authenticationType) === AuthenticationType.ServicePrincipal) {
          dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
        }
      } else {
        if (showMSIOption(workspaceId) && ((_Z = (_Y = props.formikProps) == null ? void 0 : _Y.values) == null ? void 0 : _Z.managedIdentityId) !== "" && ((_$ = (__ = props.formikProps) == null ? void 0 : __.values) == null ? void 0 : _$.managedIdentityId) !== null) {
          dataLocationComponentList.push(..._generateMSIDropdownField(isCreate, managedIdentityList));
        } else if (!!((_ba = (_aa = props.formikProps) == null ? void 0 : _aa.values) == null ? void 0 : _ba.authenticationId)) {
          dataLocationComponentList.push(..._generateServicePrincipalDropdownFields(isCreate, servicePrincipalList));
        }
      }
      return dataLocationComponentList;
    }
  };
  const _generateMSIDropdownField = (isCreate2, managedIdentityList2) => {
    var _a2, _b2;
    const dataLocationComponentList = [];
    let options = (managedIdentityList2 == null ? void 0 : managedIdentityList2.data) ? (_a2 = managedIdentityList2 == null ? void 0 : managedIdentityList2.data) == null ? void 0 : _a2.map((item) => ({ key: item.objectId, text: item.name })) : [];
    let errorMessage = "";
    if (managedIdentityList2 == null ? void 0 : managedIdentityList2.error) {
      errorMessage = "Managed identity list failed to load, please try again later and refresh the page.";
    } else if (!options || options.length === 0) {
      errorMessage = "No managed identity exist, please create a user managed identity first and refresh the page.";
    }
    dataLocationComponentList.push(
      /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          DropdownField$1,
          {
            name: "managedIdentity",
            required: true,
            label: "Managed identity",
            placeholder: "Please select your managed identity",
            ariaLabel: "Managed identity",
            options,
            isReadOnly: props.isMIReadOnly,
            defaultSelectedKey: (_b2 = props.formikProps.values.managedIdentityId) != null ? _b2 : "",
            errorMessage: getMSIErrorMessage(),
            onChange: (ev, option) => {
              var _a3, _b3;
              if (!option) {
                return;
              }
              (_a3 = props.formikProps) == null ? void 0 : _a3.setFieldValue("managedIdentityId", option.key.toString(), true);
              (_b3 = props.formikProps) == null ? void 0 : _b3.setFieldValue("managedIdentityName", option.text.toString(), true);
            }
          }
        ),
        errorMessage ? /* @__PURE__ */ jsx(
          MessageBar,
          {
            messageBarType: MessageBarType.error,
            isMultiline: false,
            dismissButtonAriaLabel: "Close",
            ariaLabel: "Managed identity Error message",
            children: errorMessage
          }
        ) : /* @__PURE__ */ jsx(Fragment, {})
      ] })
    );
    return dataLocationComponentList;
  };
  const _generateServicePrincipalDropdownFields = (isCreate2, servicePrincipalList2) => {
    var _a2, _b2, _c;
    const dataLocationComponentList = [];
    let options = ((_a2 = servicePrincipalList2 == null ? void 0 : servicePrincipalList2.data) == null ? void 0 : _a2.value) ? (_b2 = servicePrincipalList2 == null ? void 0 : servicePrincipalList2.data) == null ? void 0 : _b2.value.map((item) => ({ key: item.id, text: item.displayName })) : [];
    let errorMessage = "";
    if (!isCreate2) {
      const isItemOfOptions = options.find((item) => item.key === originalSP);
      if (!isItemOfOptions && originalSP) {
        options.push({
          key: originalSP != null ? originalSP : "",
          text: originalSP != null ? originalSP : ""
        });
      }
    }
    if (servicePrincipalList2 == null ? void 0 : servicePrincipalList2.error) {
      errorMessage = "Service principal list failed to load, please try again later and refresh the page.";
    } else if (!options || options.length === 0) {
      errorMessage = "No service principals exist, please create a principal first and refresh the page.";
    }
    dataLocationComponentList.push(
      /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          DropdownField$1,
          {
            name: "authenticationId",
            required: true,
            label: "Service Principal Name",
            placeholder: "Please select your service principal",
            ariaLabel: "Service Principal Name",
            options,
            isReadOnly: props.isMIReadOnly,
            defaultSelectedKey: (_c = props.formikProps.values.authenticationId) != null ? _c : "",
            errorMessage: getSPErrorMessage(),
            onChange: (ev, option) => {
              var _a3, _b3, _c2;
              if (!option) {
                return;
              }
              const isServicePrincipalUpdated = originalSP && originalSP !== option.key.toString();
              const isOriginalSPExistInList = (_b3 = (_a3 = servicePrincipalList2 == null ? void 0 : servicePrincipalList2.data) == null ? void 0 : _a3.value) == null ? void 0 : _b3.find((item) => item.id === originalSP);
              if (!isCreate2 && isServicePrincipalUpdated && !isOriginalSPExistInList) {
                setShowConfirmDialog(true);
                setSPNewValue(option.key.toString());
              } else {
                (_c2 = props.formikProps) == null ? void 0 : _c2.setFieldValue("authenticationId", option.key.toString(), true);
              }
            }
          }
        ),
        errorMessage ? /* @__PURE__ */ jsx(
          MessageBar,
          {
            messageBarType: MessageBarType.error,
            isMultiline: false,
            dismissButtonAriaLabel: "Close",
            ariaLabel: "Service principal Error message",
            children: errorMessage
          }
        ) : /* @__PURE__ */ jsx(Fragment, {})
      ] })
    );
    return dataLocationComponentList;
  };
  const _getCommonTextField = (Name) => {
    var _a2, _b2, _c;
    const onChange = (_2, option) => {
      var _a3, _b3, _c2, _d, _e;
      let dataLocationForms = (_b3 = (_a3 = props.formikProps) == null ? void 0 : _a3.values) == null ? void 0 : _b3.storageList;
      dataLocationForms = __spreadProps(__spreadValues({}, (_d = (_c2 = props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d.storageList), {
        [Name]: option
      });
      (_e = props.formikProps) == null ? void 0 : _e.setFieldValue("storageList", dataLocationForms, true);
    };
    const value = (_c = (_b2 = (_a2 = props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.storageList) == null ? void 0 : _c[Name];
    return _getTextField(Name, onChange, value);
  };
  const _getTextField = (Name, onChange, value, options) => {
    var _a2, _b2, _c, _d, _e, _f, _g;
    return /* @__PURE__ */ jsx(
      TextField$1,
      __spreadValues({
        label: `${LocationKeyDetailLabel[Name]}`,
        required: true,
        isReadOnly: !!props.isReadOnly,
        ariaLabel: `Please enter ${LocationKeyDetailLabel[Name]}`,
        description: getPlaceHolder(
          dataSourceCreateComponentsName.datalocationinfo,
          Name,
          (_b2 = (_a2 = props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.storageType
        ),
        value: value || "",
        errorMessage: getValidateMessage(
          Name,
          (_e = (_d = (_c = props.formikProps) == null ? void 0 : _c.values) == null ? void 0 : _d.storageList) == null ? void 0 : _e[Name],
          ((_g = (_f = props.formikProps) == null ? void 0 : _f.values) == null ? void 0 : _g.authenticationType) === AuthenticationType.ServicePrincipal
        ),
        onChange
      }, options)
    );
  };
  const getSPErrorMessage = () => {
    var _a2, _b2, _c, _d, _e, _f, _g, _h, _i;
    if (((_a2 = props.formikProps.values) == null ? void 0 : _a2.storageType) === DataLocationStorageType.ADLSGen2) {
      if (!((_b2 = props.formikProps.values) == null ? void 0 : _b2.authenticationType) || ((_c = props.formikProps.values) == null ? void 0 : _c.authenticationType) === AuthenticationType.ServicePrincipal) {
        return props.formikProps.values.authenticationId ? "" : "Required";
      } else {
        return "";
      }
    } else if (((_d = props.formikProps.values) == null ? void 0 : _d.storageType) === DataLocationStorageType.ADLSGen2CosmosView) {
      if (!((_e = props.formikProps.values) == null ? void 0 : _e.authenticationType) || ((_f = props.formikProps.values) == null ? void 0 : _f.authenticationType) === AuthenticationType.ServicePrincipal) {
        return props.formikProps.values.authenticationId ? "" : "Required";
      } else {
        return "";
      }
    } else if (((_g = props.formikProps.values) == null ? void 0 : _g.storageType) === DataLocationStorageType.Cosmos) {
      if (!((_h = props.formikProps.values) == null ? void 0 : _h.authenticationType) || ((_i = props.formikProps.values) == null ? void 0 : _i.authenticationType) === AuthenticationType.ServicePrincipal) {
        return props.formikProps.values.authenticationId ? "" : "Required";
      } else {
        return "";
      }
    }
    return props.formikProps.values.authenticationId ? "" : "Required";
  };
  const getMSIErrorMessage = () => {
    var _a2, _b2;
    if (!((_a2 = props.formikProps.values) == null ? void 0 : _a2.authenticationType) || ((_b2 = props.formikProps.values) == null ? void 0 : _b2.authenticationType) === AuthenticationType.ManagedIdentity) {
      return props.formikProps.values.managedIdentityId ? "" : "Required";
    } else {
      return "";
    }
  };
  const _onDismissDialog = () => {
    var _a2;
    setShowConfirmDialog(false);
    (_a2 = props.formikProps) == null ? void 0 : _a2.setFieldValue("authenticationId", originalSP, false);
    setSPNewValue("");
  };
  const _onConfirmDialog = () => {
    var _a2;
    setShowConfirmDialog(false);
    (_a2 = props.formikProps) == null ? void 0 : _a2.setFieldValue("authenticationId", spNewValue, false);
    setSPNewValue("");
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    _generateAuthenticationTypeDownField((_b = (_a = props.formikProps) == null ? void 0 : _a.values) == null ? void 0 : _b.storageType),
    _generateAuthenticationFields(),
    /* @__PURE__ */ jsxs(
      Dialog,
      {
        hidden: !showConfirmDialog,
        dialogContentProps: {
          title: DataLocationComponentConstants.SPDoubleConfirmDialog.title,
          type: ButtonDialogType.normal
        },
        maxWidth: 600,
        minWidth: 500,
        modalProps: {
          isBlocking: false
        },
        onRenderFooter: () => /* @__PURE__ */ jsxs(FormActions, { children: [
          /* @__PURE__ */ jsx(
            PrimaryButton,
            {
              ariaLabel: DataLocationComponentConstants.SPDoubleConfirmDialog.confirmBtn.ariaLabel,
              onClick: _onConfirmDialog,
              text: DataLocationComponentConstants.SPDoubleConfirmDialog.confirmBtn.label
            }
          ),
          /* @__PURE__ */ jsx(
            DefaultButton,
            {
              ariaLabel: DataLocationComponentConstants.SPDoubleConfirmDialog.cancelBtn.ariaLabel,
              onClick: _onDismissDialog,
              text: DataLocationComponentConstants.SPDoubleConfirmDialog.cancelBtn.ariaLabel
            }
          )
        ] }),
        children: [
          DataLocationComponentConstants.SPDoubleConfirmDialog.subText,
          /* @__PURE__ */ jsx("br", {}),
          DataLocationComponentConstants.SPDoubleConfirmDialog.getInfo(originalSP != null ? originalSP : "")
        ]
      }
    )
  ] });
}
function DataLocationInfoComponent(props) {
  var _a, _b, _c, _d, _e, _f;
  const { isCreate } = props;
  const [optionList, setOptionList] = useState([]);
  const dispatch = useDispatch();
  const workspaceId = useSelector((state) => {
    var _a2, _b2;
    return ((_b2 = (_a2 = state.currentUserDetails.userAffinity) == null ? void 0 : _a2.data) == null ? void 0 : _b2.workspaceId) || "";
  });
  React.useEffect(() => {
    const _optionList = props.formikProps.values.dataSourceType !== DataSourceTypes.Sample ? dataSourceDataTypeList.map(({ DataType: DataType2, StorageType: StorageType2, FileFormat: FileFormat2 }) => ({
      key: StorageType2,
      text: DataType2,
      data: { fileFormat: FileFormat2, storageType: StorageType2 }
    })) : sampleDataSourceDataTypeList.map(({ DataType: DataType2, StorageType: StorageType2, FileFormat: FileFormat2 }) => ({
      key: StorageType2,
      text: DataType2,
      data: { fileFormat: FileFormat2, storageType: StorageType2 }
    }));
    if (!isCreate) {
      dispatch(loadServicePrincipalNameListEpicReducer.actionCreators.load({ workspaceId }));
      dispatchManagedIdentityNameList();
    }
    setOptionList(_optionList);
  }, [isCreate, workspaceId, dispatch]);
  const dispatchManagedIdentityNameList = () => {
    if (showMSIOption(workspaceId)) {
      dispatch(loadManagedIdentityNameListEpicReducer.actionCreators.load({ workspaceId }));
    }
  };
  const getMTLocationTextField = (Name) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g;
    const onChange = (_2, option) => {
      var _a3, _b3, _c3, _d3;
      let dataLocationForms = (_c3 = (_b3 = (_a3 = props.formikProps) == null ? void 0 : _a3.values) == null ? void 0 : _b3.storageMTList[0]) != null ? _c3 : { DataPath: "", EndPoint: "" };
      dataLocationForms = __spreadProps(__spreadValues({}, dataLocationForms), {
        [Name]: option
      });
      (_d3 = props.formikProps) == null ? void 0 : _d3.setFieldValue("storageMTList", [dataLocationForms], true);
    };
    const value = (_c2 = (_b2 = (_a2 = props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.storageMTList[0]) == null ? void 0 : _c2[Name];
    return _getTextField(Name, onChange, value, {
      errorMessage: getValidateMessage(Name, (_g = (_f2 = (_e2 = (_d2 = props.formikProps) == null ? void 0 : _d2.values) == null ? void 0 : _e2.storageMTList) == null ? void 0 : _f2[0]) == null ? void 0 : _g[Name])
    });
  };
  const getRetentionDaysTextField = () => {
    var _a2, _b2, _c2, _d2, _e2;
    const values = (_a2 = props.formikProps) == null ? void 0 : _a2.values;
    const retentionDaysValue = (values == null ? void 0 : values.retentionDays) ? values == null ? void 0 : values.retentionDays.toString() : "";
    const errorMsgValue = (values == null ? void 0 : values.retentionErrorMsg) ? values.retentionErrorMsg : "";
    const onRetentionDaysChange = (_2, option) => {
      var _a3;
      (_a3 = props.formikProps) == null ? void 0 : _a3.setFieldValue("retentionDays", option, true);
    };
    const retentionDaysField = _getTextField("RetentionDays", onRetentionDaysChange, retentionDaysValue, {
      description: "e.g. 30",
      errorMessage: getValidateMessage("RetentionDays", (_c2 = (_b2 = props.formikProps) == null ? void 0 : _b2.values) == null ? void 0 : _c2.retentionDays),
      required: false,
      labelProps: {
        iconProps: {
          calloutProps: {
            content: "Enter the number of days for which data is guaranteed to exist and is interoperable. Experimenters will be able to create scorecards only for the date range that fits within the retention period."
          }
        }
      }
    });
    const onRetentionDayErrorMsgChange = (_2, option) => {
      var _a3;
      (_a3 = props.formikProps) == null ? void 0 : _a3.setFieldValue("retentionErrorMsg", option, true);
    };
    const errorMsgField = _getTextField("RetentionDaysErrorMsg", onRetentionDayErrorMsgChange, errorMsgValue, {
      description: "Please input error message",
      errorMessage: getValidateMessage("RetentionDaysErrorMsg", (_e2 = (_d2 = props.formikProps) == null ? void 0 : _d2.values) == null ? void 0 : _e2.retentionErrorMsg),
      required: false
    });
    return [retentionDaysField, errorMsgField];
  };
  const _getCommonTextField = (Name) => {
    var _a2, _b2, _c2;
    const onChange = (_2, option) => {
      var _a3, _b3, _c3, _d2, _e2;
      let dataLocationForms = (_b3 = (_a3 = props.formikProps) == null ? void 0 : _a3.values) == null ? void 0 : _b3.storageList;
      dataLocationForms = __spreadProps(__spreadValues({}, (_d2 = (_c3 = props.formikProps) == null ? void 0 : _c3.values) == null ? void 0 : _d2.storageList), {
        [Name]: option
      });
      (_e2 = props.formikProps) == null ? void 0 : _e2.setFieldValue("storageList", dataLocationForms, true);
    };
    const value = (_c2 = (_b2 = (_a2 = props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.storageList) == null ? void 0 : _c2[Name];
    return _getTextField(Name, onChange, value);
  };
  const _getTextField = (Name, onChange, value, options) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g;
    return /* @__PURE__ */ jsx(
      TextField$1,
      __spreadValues({
        label: `${LocationKeyDetailLabel[Name]}`,
        required: true,
        isReadOnly: !!props.isReadOnly,
        ariaLabel: `Please enter ${LocationKeyDetailLabel[Name]}`,
        description: getPlaceHolder(
          dataSourceCreateComponentsName.datalocationinfo,
          Name,
          (_b2 = (_a2 = props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.storageType
        ),
        value: value || "",
        errorMessage: getValidateMessage(
          Name,
          (_e2 = (_d2 = (_c2 = props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d2.storageList) == null ? void 0 : _e2[Name],
          ((_g = (_f2 = props.formikProps) == null ? void 0 : _f2.values) == null ? void 0 : _g.authenticationType) === AuthenticationType.ServicePrincipal
        ),
        onChange
      }, options)
    );
  };
  const _handleDataTypeChange = (option) => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g, _h, _i, _j;
    const { fileFormat = "", storageType = "" } = (_a2 = option == null ? void 0 : option.data) != null ? _a2 : {};
    (_b2 = props.formikProps) == null ? void 0 : _b2.setFieldValue("storageList", {}, false);
    (_c2 = props.formikProps) == null ? void 0 : _c2.setFieldValue("storageMTList", [], false);
    (_d2 = props.formikProps) == null ? void 0 : _d2.setFieldValue("parameterList", [], true);
    const currentOptionKey = `${storageType}-${fileFormat}`;
    switch (currentOptionKey) {
      case DataLocationDataType.ADLSGen2CosmosView:
        dispatch(loadServicePrincipalNameListEpicReducer.actionCreators.load({ workspaceId }));
        dispatchManagedIdentityNameList();
        (_e2 = props.formikProps) == null ? void 0 : _e2.setFieldValue("parameterList", getCosmosViewDefaultParameter(), true);
        break;
      case DataLocationDataType.CosmosCosmosView:
        dispatch(loadServicePrincipalNameListEpicReducer.actionCreators.load({ workspaceId }));
        dispatchManagedIdentityNameList();
        (_f2 = props.formikProps) == null ? void 0 : _f2.setFieldValue("storageList", CosmosDataLocation, true);
        (_g = props.formikProps) == null ? void 0 : _g.setFieldValue("parameterList", getCosmosViewDefaultParameter(), true);
        break;
      case DataLocationDataType.AzureBlobParquet:
        dispatchManagedIdentityNameList();
        (_h = props.formikProps) == null ? void 0 : _h.setFieldValue(
          "storageList",
          __spreadValues({}, AzureBlobLocation),
          true
        );
        break;
      case DataLocationDataType.ADLSGen2Parquet:
        dispatch(loadServicePrincipalNameListEpicReducer.actionCreators.load({ workspaceId }));
        dispatchManagedIdentityNameList();
        (_i = props.formikProps) == null ? void 0 : _i.setFieldValue(
          "storageList",
          __spreadValues({}, ADLSGen2Location),
          true
        );
        break;
      case DataLocationDataType.MTParquet:
        (_j = props.formikProps) == null ? void 0 : _j.setFieldValue("storageMTList", [{ DataPath: "", EndPoint: "", Region: "" }], true);
        break;
    }
    props.formikProps.setFieldValue(
      "flightList",
      _.map(props.formikProps.values.flightList, (item) => {
        return __spreadProps(__spreadValues({}, item), {
          Format: "",
          Key: null,
          Definition: null,
          Source: null
        });
      }),
      true
    );
  };
  const _generateDataLocationFields = (isCreate2, storageType, data) => {
    var _a2, _b2;
    switch (storageType) {
      case DataLocationStorageType.MT:
        return [getMTLocationTextField("DataPath"), getMTLocationTextField("EndPoint")];
      default:
        let index = _getTypeIndex((_b2 = (_a2 = props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.storageType);
        const dataLocationComponentList = [];
        _.each(data == null ? void 0 : data[index].LocationProperties, (rawItem, Name) => {
          if (Name === "TenantId" || Name === "Environment")
            return;
          if (Name !== "KeyVaultAuthentication") {
            dataLocationComponentList.push(_getCommonTextField(Name));
          }
        });
        return dataLocationComponentList;
    }
  };
  const _getTypeIndex = (type) => {
    let index = 0;
    _.each(optionList, (item, key) => {
      if (item.key === type) {
        index = key;
      }
    });
    return index;
  };
  let dataLocationComponent = [];
  if ((_b = (_a = props.formikProps) == null ? void 0 : _a.values) == null ? void 0 : _b.storageType) {
    dataLocationComponent = _generateDataLocationFields(
      isCreate,
      (_d = (_c = props.formikProps) == null ? void 0 : _c.values) == null ? void 0 : _d.storageType,
      dataSourceDataTypeList
    );
  }
  const _generateOptionalFields = () => {
    var _a2, _b2;
    const storageType = (_b2 = (_a2 = props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.storageType;
    if (storageType) {
      let dataLocationComponent2 = [];
      dataLocationComponent2.push(...getRetentionDaysTextField());
      dataLocationComponent2.push(getAAStreamLocationPrefixFields(props.formikProps, props.isReadOnly));
      dataLocationComponent2.push(getAAStreamExpiryDaysField(props.formikProps, props.isReadOnly));
      return dataLocationComponent2;
    }
  };
  return /* @__PURE__ */ jsxs(StepContainer, { className: "create-datalocation-info-tab", children: [
    !props.isUpdateDataSource && /* @__PURE__ */ jsx(FormHeading, { pageTitle: CreateStepTitle.Location, children: "This is where you enter details about the location of your data." }),
    /* @__PURE__ */ jsxs(FormSection, { children: [
      /* @__PURE__ */ jsx(
        DropdownField$1,
        {
          label: "Data type",
          name: `storageType`,
          ariaLabel: "Data type",
          placeholder: getPlaceHolder(dataSourceCreateComponentsName.datalocationinfo, "datatype"),
          options: optionList,
          selectedKey: (_f = (_e = props.formikProps) == null ? void 0 : _e.values) == null ? void 0 : _f.storageType,
          required: true,
          isReadOnly: !!props.isReadOnly,
          onChange: (ev, option) => {
            var _a2;
            (_a2 = props.formikProps) == null ? void 0 : _a2.setFieldValue("storageType", option == null ? void 0 : option.data.storageType, true);
            _handleDataTypeChange(option);
          }
        }
      ),
      dataLocationComponent,
      /* @__PURE__ */ jsx(DataLocationAuthtencationFileds, __spreadValues({}, props)),
      _generateOptionalFields()
    ] })
  ] });
}
const textStyles = {
  root: { maxWidth: 60, display: "inline-block" }
};
const mapStateToProps$2 = (state) => {
  return {};
};
const mapDispatchToProps$2 = {};
var defaultParameters = /* @__PURE__ */ ((defaultParameters2) => {
  defaultParameters2["startDateTime"] = "e.g. StartDate";
  defaultParameters2["endDateTime"] = "e.g. EndDate";
  return defaultParameters2;
})(defaultParameters || {});
class ParametersInfoComponent extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "_selection");
    this._selection = new Selection({
      canSelectItem: (item, index) => {
        var _a, _b;
        if (((_b = (_a = this.props.formikProps) == null ? void 0 : _a.values) == null ? void 0 : _b.storageType) === DataLocationStorageType.Cosmos && (index === 0 || index === 1)) {
          return false;
        } else {
          return true;
        }
      }
    });
  }
  render() {
    var _a, _b, _c, _d;
    const items = [];
    items.push({
      key: "add-datasource-parameter",
      ariaLabel: "Add parameter",
      disabled: !!this.props.isReadOnly,
      iconProps: {
        iconName: "Add"
      },
      name: "Add parameter",
      onClick: () => {
        var _a2, _b2, _c2, _d2, _e, _f;
        let parameterList = [
          ...((_b2 = (_a2 = this.props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.parameterList) ? (_d2 = (_c2 = this.props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d2.parameterList : [],
          {
            Name: "",
            Type: "",
            Value: "",
            SampleValue: "",
            delete: null,
            required: {
              Name: "Required",
              Type: "Required",
              Value: "Required",
              SampleValue: ""
            }
          }
        ];
        (_f = (_e = this.props.formikProps) == null ? void 0 : _e.setFieldValue) == null ? void 0 : _f.call(_e, "parameterList", parameterList, true);
      }
    });
    items.push({
      key: "delete-datasource-parameter",
      ariaLabel: "Delete parameter",
      disabled: !!this.props.isReadOnly,
      iconProps: {
        iconName: "Delete"
      },
      name: "Delete",
      onClick: () => {
        var _a2, _b2, _c2, _d2, _e, _f, _g, _h;
        const index = this._selection.getSelectedIndices();
        if (index.length <= 0)
          return;
        if ((_b2 = (_a2 = this.props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.parameterList) {
          let parameterList = [
            ...(_d2 = (_c2 = this.props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d2.parameterList.slice(0, index[0]),
            ...(_f = (_e = this.props.formikProps) == null ? void 0 : _e.values) == null ? void 0 : _f.parameterList.slice(index[0] + 1)
          ];
          (_h = (_g = this.props.formikProps) == null ? void 0 : _g.setFieldValue) == null ? void 0 : _h.call(_g, "parameterList", parameterList, true);
        }
      }
    });
    return /* @__PURE__ */ jsxs(StepContainer, { className: "create-parameters-info-tab", layout: StepLayouts.fullWidth, children: [
      !this.props.isUpdateDataSource && /* @__PURE__ */ jsx(FormHeading, { pageTitle: CreateStepTitle.Parameters, children: "This is where you define parameters of your data source and set default values for them." }),
      /* @__PURE__ */ jsx(FormSection, { children: /* @__PURE__ */ jsx(
        DetailsListWithCommandBar,
        {
          commandBarProps: { ariaLabel: "action items for data source parameter list", items },
          detailsListProps: {
            selection: this._selection,
            selectionMode: SelectionMode.single,
            items: ((_b = (_a = this.props.formikProps) == null ? void 0 : _a.values) == null ? void 0 : _b.parameterList) ? (_d = (_c = this.props.formikProps) == null ? void 0 : _c.values) == null ? void 0 : _d.parameterList : [],
            onRenderItemColumn: (item, index, column) => this._onRenderItemColumn(item, index, column),
            columns: [
              {
                key: ColumnMultilineKey.Name,
                name: "Name",
                minWidth: 100,
                maxWidth: 150,
                fieldName: "Name",
                data: "string",
                isResizable: true
              },
              {
                key: ColumnMultilineKey.Type,
                name: "Type",
                minWidth: 150,
                maxWidth: 150,
                fieldName: "Type",
                data: "string",
                isResizable: true
              },
              {
                key: ColumnMultilineKey.Value,
                name: "Value",
                minWidth: 100,
                maxWidth: 250,
                fieldName: "Value",
                data: "string",
                isResizable: true
              },
              {
                key: ColumnMultilineKey.SampleValue,
                name: "Sample value",
                minWidth: 100,
                maxWidth: 450,
                fieldName: "SampleValue",
                data: "string",
                isResizable: true
              }
            ],
            defaultSortColumn: "",
            disableSort: true,
            ariaLabelForGrid: "parameters info"
          }
        }
      ) })
    ] });
  }
  _updateStartOrEndDate(updateDateObj) {
    let paramter = updateDateObj.parameterList[updateDateObj.currentPos];
    let columnNewValue = paramter.SampleValue;
    if (updateDateObj.currentPos === updateDateObj.index) {
      columnNewValue = updateDateObj.newValue ? updateDateObj.newValue : "";
    }
    let required = "";
    if (columnNewValue === void 0 || "" === columnNewValue.trim()) {
      required = "Required";
    } else {
      required = getValidateMessage(parameterType.CosmosDateNumber, columnNewValue);
    }
    if ("" === required) {
      const start = updateDateObj.index === 0 ? updateDateObj.newValue : updateDateObj.parameterList[0].SampleValue;
      const end = updateDateObj.index === 1 ? updateDateObj.newValue : updateDateObj.parameterList[1].SampleValue;
      required = getValidateCosmosDateTimeDiff(start, end);
    }
    updateDateObj.parameterList = [
      ...updateDateObj.parameterList.slice(0, updateDateObj.currentPos),
      __spreadProps(__spreadValues({}, paramter), {
        [updateDateObj.column.key]: columnNewValue,
        required: __spreadProps(__spreadValues({}, paramter.required), {
          [updateDateObj.column.key]: required
        })
      }),
      ...updateDateObj.parameterList.slice(updateDateObj.currentPos + 1)
    ];
    return updateDateObj.parameterList;
  }
  _genCosmosStartEndDateValue(item, fieldName, index, column) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    if (ColumnMultilineKey.Value === fieldName) {
      return /* @__PURE__ */ jsx("div", { children: `${((_b = (_a = this.props.formikProps) == null ? void 0 : _a.values) == null ? void 0 : _b.parameterList) && ((_d = (_c = this.props.formikProps) == null ? void 0 : _c.values) == null ? void 0 : _d.parameterList[index][column.key])}` });
    } else if (ColumnMultilineKey.SampleValue === fieldName) {
      return /* @__PURE__ */ jsxs("div", { style: { display: "flex" }, children: [
        'today( "',
        /* @__PURE__ */ jsx(
          TextField$1,
          {
            styles: textStyles,
            value: `${(_f = (_e = this.props.formikProps) == null ? void 0 : _e.values) == null ? void 0 : _f.parameterList[index][column.key]}`,
            ariaLabel: `Parameter ${column.key}`,
            errorMessage: `${((_h = (_g = this.props.formikProps) == null ? void 0 : _g.values) == null ? void 0 : _h.parameterList) && (((_j = (_i = this.props.formikProps) == null ? void 0 : _i.touched) == null ? void 0 : _j.parameterList) ? (_l = (_k = this.props.formikProps) == null ? void 0 : _k.values) == null ? void 0 : _l.parameterList[index]["required"][column.key] : "")}`,
            isReadOnly: !!this.props.isReadOnly,
            onChange: (props, newValue) => {
              var _a2, _b2, _c2, _d2, _e2, _f2;
              let parameterList = ((_b2 = (_a2 = this.props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.parameterList) ? (_d2 = (_c2 = this.props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d2.parameterList : [];
              if (parameterList[0] && parameterList[1]) {
                let i = index;
                parameterList = this._updateStartOrEndDate({
                  parameterList,
                  newValue,
                  column,
                  currentPos: i,
                  index
                });
                parameterList = this._updateStartOrEndDate({
                  parameterList,
                  newValue,
                  column,
                  currentPos: i === 0 ? 1 : 0,
                  index
                });
                (_f2 = (_e2 = this.props.formikProps) == null ? void 0 : _e2.setFieldValue) == null ? void 0 : _f2.call(_e2, "parameterList", parameterList, true);
              }
            }
          }
        ),
        '" )'
      ] });
    }
  }
  _onRenderItemColumn(item, index, column) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B;
    const { fieldName = "" } = column || {};
    if (!column || !fieldName || index === void 0)
      return null;
    switch (fieldName) {
      case "Type":
        if (item.placeholder && (item.placeholder.Name === "e.g. StartDate" || item.placeholder.Name === "e.g. EndDate")) {
          return parameterType.SystemString;
        }
        return /* @__PURE__ */ jsx(
          Dropdown,
          {
            ariaLabel: `Parameter ${column.key}-${index}`,
            isReadOnly: !!this.props.isReadOnly,
            options: [
              { key: parameterType.SystemString, text: parameterType.SystemString },
              { key: parameterType.SystemBoolean, text: parameterType.SystemBoolean },
              { key: parameterType.SystemInt32, text: parameterType.SystemInt32 },
              { key: parameterType.SystemInt64, text: parameterType.SystemInt64 },
              { key: parameterType.SystemDouble, text: parameterType.SystemDouble }
            ],
            required: true,
            styles: { root: { paddingRight: "9px" } },
            placeholder: getPlaceHolder(dataSourceCreateComponentsName.parametersinfo, column.key),
            errorMessage: `${((_b = (_a = this.props.formikProps) == null ? void 0 : _a.values) == null ? void 0 : _b.parameterList) && (((_d = (_c = this.props.formikProps) == null ? void 0 : _c.touched) == null ? void 0 : _d.parameterList) ? (_f = (_e = this.props.formikProps) == null ? void 0 : _e.values) == null ? void 0 : _f.parameterList[index]["required"][column.key] : "")}`,
            selectedKey: ((_h = (_g = this.props.formikProps) == null ? void 0 : _g.values) == null ? void 0 : _h.parameterList) ? (_j = (_i = this.props.formikProps) == null ? void 0 : _i.values) == null ? void 0 : _j.parameterList[index][column.key] : "",
            onChange: (ev, option) => {
              var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2, _n2, _o2, _p2;
              if (!option) {
                return;
              }
              let newValue = option == null ? void 0 : option.text;
              let parameterList = ((_b2 = (_a2 = this.props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.parameterList) ? (_d2 = (_c2 = this.props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d2.parameterList : [];
              if (parameterList[index]) {
                let paramter = parameterList[index];
                let columnNewValue = newValue ? newValue : "";
                let required = "";
                if (newValue === void 0 || "" === newValue.trim()) {
                  required = "Required";
                }
                let validateValue = "";
                let validateSample = "";
                if (paramter.Value === void 0 || "" === paramter.Value.trim()) {
                  validateValue = "Required";
                } else {
                  if (((_f2 = (_e2 = this.props.formikProps) == null ? void 0 : _e2.values) == null ? void 0 : _f2.storageType) !== DataLocationStorageType.AzureBlob || newValue !== parameterType.SystemString) {
                    validateValue = getValidateMessage(newValue, paramter.Value);
                  }
                }
                if (paramter.SampleValue && "" !== paramter.SampleValue.trim()) {
                  if (((_h2 = (_g2 = this.props.formikProps) == null ? void 0 : _g2.values) == null ? void 0 : _h2.storageType) !== DataLocationStorageType.AzureBlob || newValue !== parameterType.SystemString) {
                    validateSample = getValidateMessage(newValue, paramter.SampleValue);
                  }
                }
                if ((_j2 = (_i2 = this.props.formikProps) == null ? void 0 : _i2.values) == null ? void 0 : _j2.parameterList) {
                  parameterList = [
                    ...(_l2 = (_k2 = this.props.formikProps) == null ? void 0 : _k2.values) == null ? void 0 : _l2.parameterList.slice(0, index),
                    __spreadProps(__spreadValues({}, paramter), {
                      [column.key]: columnNewValue,
                      required: __spreadProps(__spreadValues({}, paramter.required), {
                        Value: validateValue,
                        SampleValue: validateSample,
                        [column.key]: required
                      })
                    }),
                    ...(_n2 = (_m2 = this.props.formikProps) == null ? void 0 : _m2.values) == null ? void 0 : _n2.parameterList.slice(index + 1)
                  ];
                } else {
                  parameterList = [];
                }
                (_p2 = (_o2 = this.props.formikProps) == null ? void 0 : _o2.setFieldValue) == null ? void 0 : _p2.call(_o2, "parameterList", parameterList, true);
              }
            }
          }
        );
      default:
        if (item.placeholder && (item.placeholder.Name === "e.g. StartDate" || item.placeholder.Name === "e.g. EndDate") && fieldName !== "Name" && fieldName !== "delete") {
          return this._genCosmosStartEndDateValue(item, fieldName, index, column);
        } else
          return /* @__PURE__ */ jsx(
            TextField$1,
            {
              value: `${((_l = (_k = this.props.formikProps) == null ? void 0 : _k.values) == null ? void 0 : _l.parameterList) && ((_n = (_m = this.props.formikProps) == null ? void 0 : _m.values) == null ? void 0 : _n.parameterList[index][column.key])}`,
              ariaLabel: `Parameter ${column.key}`,
              isReadOnly: !!this.props.isReadOnly,
              description: ((_p = (_o = this.props.formikProps) == null ? void 0 : _o.values) == null ? void 0 : _p.parameterList) && ((_r = (_q = this.props.formikProps) == null ? void 0 : _q.values) == null ? void 0 : _r.parameterList[index]) && ((_t = (_s = this.props.formikProps) == null ? void 0 : _s.values) == null ? void 0 : _t.parameterList[index]["placeholder"]) ? (_v = (_u = this.props.formikProps) == null ? void 0 : _u.values) == null ? void 0 : _v.parameterList[index]["placeholder"][column.key] : getPlaceHolder(dataSourceCreateComponentsName.parametersinfo, column.key),
              required: column.key === ColumnMultilineKey.SampleValue ? false : true,
              multiline: column.key === ColumnMultilineKey.Value || column.key === ColumnMultilineKey.SampleValue ? true : false,
              onKeyDownCapture: (event) => {
                var _a2, _b2, _c2, _d2;
                const length = ((_b2 = (_a2 = this.props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.parameterList) ? ((_d2 = (_c2 = this.props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d2.parameterList[index][column.key]).length : 0;
                if (event.keyCode === 37 || event.keyCode === 38) {
                  if (event.currentTarget.selectionStart !== null && event.currentTarget.selectionStart > 0) {
                    event.stopPropagation();
                  }
                }
                if (event.keyCode === 39 || event.keyCode === 40) {
                  if (event.currentTarget.selectionEnd !== null && event.currentTarget.selectionEnd < length) {
                    event.stopPropagation();
                  }
                }
              },
              errorMessage: `${((_x = (_w = this.props.formikProps) == null ? void 0 : _w.values) == null ? void 0 : _x.parameterList) && (((_z = (_y = this.props.formikProps) == null ? void 0 : _y.touched) == null ? void 0 : _z.parameterList) ? (_B = (_A = this.props.formikProps) == null ? void 0 : _A.values) == null ? void 0 : _B.parameterList[index]["required"][column.key] : "")}`,
              onChange: (props, newValue) => {
                var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
                let parameterList = (_b2 = (_a2 = this.props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.parameterList;
                if (parameterList[index]) {
                  let paramter = parameterList[index];
                  let columnNewValue = newValue ? newValue : "";
                  let required = "";
                  if ((newValue === void 0 || "" === newValue.trim()) && column.key !== ColumnMultilineKey.SampleValue) {
                    required = "Required";
                  }
                  if (column.key === ColumnMultilineKey.Value || column.key === ColumnMultilineKey.SampleValue && columnNewValue !== "") {
                    if (((_d2 = (_c2 = this.props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d2.storageType) !== DataLocationStorageType.AzureBlob || item.Type !== parameterType.SystemString) {
                      required = getValidateMessage(item.Type, columnNewValue);
                    }
                  }
                  if ((_f2 = (_e2 = this.props.formikProps) == null ? void 0 : _e2.values) == null ? void 0 : _f2.parameterList) {
                    parameterList = [
                      ...(_h2 = (_g2 = this.props.formikProps) == null ? void 0 : _g2.values) == null ? void 0 : _h2.parameterList.slice(0, index),
                      __spreadProps(__spreadValues({}, paramter), {
                        [column.key]: columnNewValue,
                        required: __spreadProps(__spreadValues({}, paramter.required), {
                          [column.key]: required
                        })
                      }),
                      ...(_j2 = (_i2 = this.props.formikProps) == null ? void 0 : _i2.values) == null ? void 0 : _j2.parameterList.slice(index + 1)
                    ];
                  } else {
                    parameterList = [];
                  }
                  (_l2 = (_k2 = this.props.formikProps) == null ? void 0 : _k2.setFieldValue) == null ? void 0 : _l2.call(_k2, "parameterList", parameterList, true);
                }
              }
            }
          );
    }
  }
}
const ParametersInfoComponent$1 = connect(mapStateToProps$2, mapDispatchToProps$2)(ParametersInfoComponent);
function validateBlueshiftDependencyPath(value) {
  const invalidCharacters = ["\\", "*", "?", '"', "<", ">", "|"];
  const blueshiftDependencyFileRegexes = [
    new RegExp("^https:\\/\\/(?<account>\\w+)\\.blob\\.core\\.windows\\.net\\/(?<container>[\\w-]+)\\/(?<filepath>.*)$"),
    new RegExp("^abfss:\\/\\/(?<container>[\\w-]+)@(?<account>\\w+)\\.dfs.core.windows.net\\/(?<filepath>.*)$")
  ];
  if (!value.includes(":") && invalidCharacters.some((c) => value.includes(c))) {
    return `The dependency file relative path: ${value} shouldn't contain the invalid characters: '\\', '*', '?', '"', '<', '>', '|'`;
  }
  const isMatched = blueshiftDependencyFileRegexes.some((regex) => regex.test(value));
  if (value.includes(":") && !isMatched) {
    return `The path of dependency file ${value} doesn't match the format: 'https://<account>.blob.core.windows.net/<container>/<filePath>' or 'abfss://<container>@<account>.dfs.core.windows.net/<filePath>'`;
  }
  return "";
}
function DataPathField(props) {
  var _a, _b, _c;
  const { formikProps, index } = props;
  const key = "DataPath";
  return /* @__PURE__ */ jsx(
    TextField$2,
    {
      ariaLabel: `Availability stream ${key}`,
      isReadOnly: !!props.isReadOnly,
      required: true,
      description: getPlaceHolder(dataSourceCreateComponentsName.availabilitystreaminfo, key),
      value: `${((_a = formikProps == null ? void 0 : formikProps.values) == null ? void 0 : _a.streamList) && ((_b = formikProps == null ? void 0 : formikProps.values) == null ? void 0 : _b.streamList[index][key])}`,
      errorMessage: validateBlueshiftDependencyPath((_c = formikProps == null ? void 0 : formikProps.values) == null ? void 0 : _c.streamList[index][key]),
      onChange: (props2, newValue) => {
        var _a2, _b2, _c2;
        let streamList = [...(_a2 = formikProps == null ? void 0 : formikProps.values) == null ? void 0 : _a2.streamList];
        if (streamList && streamList[index]) {
          const stream = streamList[index];
          const columnNewValue = (newValue == null ? void 0 : newValue.trim()) || "";
          const validationMessage = columnNewValue ? validateBlueshiftDependencyPath(columnNewValue) : "Required";
          const updatedStreamList = (_c2 = (_b2 = formikProps == null ? void 0 : formikProps.values) == null ? void 0 : _b2.streamList) == null ? void 0 : _c2.map((value, i) => {
            if (i === index) {
              return __spreadProps(__spreadValues({}, stream), {
                [key]: columnNewValue,
                required: __spreadProps(__spreadValues({}, stream.required), {
                  [key]: validationMessage
                })
              });
            }
            return value;
          });
          formikProps == null ? void 0 : formikProps.setFieldValue("streamList", updatedStreamList);
        }
      }
    }
  );
}
const mapStateToProps$1 = (state) => {
  return {};
};
const mapDispatchToProps$1 = {};
class AvailabilityStreamInfoComponent extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "_selection");
    this._selection = new Selection();
  }
  render() {
    var _a, _b, _c, _d;
    const items = [];
    items.push({
      key: "add-datasource-availability",
      ariaLabel: "Add dependency file",
      disabled: !!this.props.isReadOnly,
      iconProps: {
        iconName: "Add"
      },
      name: "Add dependency file",
      onClick: () => {
        var _a2, _b2, _c2, _d2, _e, _f;
        let streamList = [
          ...((_b2 = (_a2 = this.props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.streamList) ? (_d2 = (_c2 = this.props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d2.streamList : [],
          {
            DataPath: "",
            VC: "",
            Cluster: "",
            delete: null,
            required: {
              DataPath: "Required",
              VC: "",
              Cluster: ""
            }
          }
        ];
        (_f = (_e = this.props.formikProps) == null ? void 0 : _e.setFieldValue) == null ? void 0 : _f.call(_e, "streamList", streamList, true);
      }
    });
    items.push({
      key: "delete-datasource-availability",
      ariaLabel: "Delete availability",
      disabled: !!this.props.isReadOnly,
      iconProps: {
        iconName: "Delete"
      },
      name: "Delete",
      onClick: () => {
        var _a2, _b2, _c2, _d2, _e, _f, _g, _h;
        const index = this._selection.getSelectedIndices();
        if (index.length <= 0)
          return;
        let streamList = [];
        if ((_b2 = (_a2 = this.props.formikProps) == null ? void 0 : _a2.values) == null ? void 0 : _b2.streamList) {
          streamList = [
            ...(_d2 = (_c2 = this.props.formikProps) == null ? void 0 : _c2.values) == null ? void 0 : _d2.streamList.slice(0, index[0]),
            ...(_f = (_e = this.props.formikProps) == null ? void 0 : _e.values) == null ? void 0 : _f.streamList.slice(index[0] + 1)
          ];
        }
        (_h = (_g = this.props.formikProps) == null ? void 0 : _g.setFieldValue) == null ? void 0 : _h.call(_g, "streamList", streamList, true);
      }
    });
    return /* @__PURE__ */ jsxs(StepContainer, { className: "create-availabilitystream-info-tab", layout: StepLayouts.fullWidth, children: [
      !this.props.isUpdateDataSource && /* @__PURE__ */ jsx(FormHeading, { pageTitle: CreateStepTitle.Availability, children: "This is where you optionally add any dependency files for your data source." }),
      /* @__PURE__ */ jsx(FormSection, { children: /* @__PURE__ */ jsx(
        DetailsListWithCommandBar,
        {
          commandBarProps: { ariaLabel: "action items for data source dependency file list", items },
          detailsListProps: {
            selection: this._selection,
            selectionMode: SelectionMode.single,
            items: ((_b = (_a = this.props.formikProps) == null ? void 0 : _a.values) == null ? void 0 : _b.streamList) ? (_d = (_c = this.props.formikProps) == null ? void 0 : _c.values) == null ? void 0 : _d.streamList : [],
            columns: [
              {
                key: "DataPath",
                name: "Data path",
                minWidth: 280,
                fieldName: "DataPath",
                data: "string",
                onRender: (item, index, column) => {
                  return /* @__PURE__ */ jsx(DataPathField, { formikProps: this.props.formikProps, index: index != null ? index : 0 });
                }
              }
            ],
            defaultSortColumn: "DataPath",
            ariaLabelForGrid: "availability stream info"
          }
        }
      ) })
    ] });
  }
}
const AvailabilityStreamInfoComponent$1 = connect(
  mapStateToProps$1,
  mapDispatchToProps$1
)(AvailabilityStreamInfoComponent);
const SpecialColumnsComponent = (props) => {
  var _a;
  const flightFormats = (_a = useSelector((state) => state.dataSourceManagementModule.dataSourceFlightFormats.items.data)) != null ? _a : [];
  const selectionRandomizationUnit = useRef(new Selection());
  const selectionFlight = useRef(new Selection());
  const selectionTimestamp = useRef(new Selection());
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      loadDataSourceFlightFormatsEpicReducer.actionCreators.load({
        workspaceId: props.workspaceId,
        dataSourceType: props.storageType ? props.storageType : "Cosmos"
      })
    );
  }, [props.workspaceId, props.storageType, props.loadDataSourceFlightFormats, dispatch]);
  const _onRenderUnmanagedList = (key, name, listName, errorMessages, list, selection, columns2, defaultValue, onRenderColumn, dropdownList) => {
    const items = [];
    items.push({
      key: `Add-${key}`,
      ariaLabel: `Add ${name.toLowerCase()}`,
      disabled: !!props.isReadOnly,
      iconProps: {
        iconName: "Add"
      },
      name: `Add ${name.toLowerCase()}`,
      onClick: () => {
        var _a2;
        let newList = [...list ? list : [], defaultValue];
        (_a2 = props.setFieldValue) == null ? void 0 : _a2.call(props, listName, newList, true);
      }
    });
    items.push({
      key: `Delete-${key}`,
      ariaLabel: `Delete ${name.toLowerCase()}`,
      disabled: !!props.isReadOnly || list.length <= 0,
      iconProps: {
        iconName: "Delete"
      },
      name: "Delete",
      onClick: () => {
        var _a2;
        const index = selection.getSelectedIndices();
        if (index.length <= 0)
          return;
        let newList = [];
        if (list) {
          newList = [...list.slice(0, index[0]), ...list.slice(index[0] + 1)];
        }
        (_a2 = props.setFieldValue) == null ? void 0 : _a2.call(props, listName, newList, true);
      }
    });
    return /* @__PURE__ */ jsx(Accordion, { ariaLabel: name, header: name, showContentOnRender: true, children: /* @__PURE__ */ jsx(
      DetailsListWithCommandBar,
      {
        commandBarProps: { ariaLabel: `action items for ${name.toLowerCase()}`, items },
        errors: errorMessages,
        detailsListProps: {
          ariaLabelForGrid: "Special columns unmanaged list",
          selection,
          selectionMode: SelectionMode.single,
          onRenderItemColumn: (item, index, column) => onRenderColumn == null ? void 0 : onRenderColumn(key, listName, !!props.isReadOnly, list, index, column, dropdownList),
          items: list ? list : [],
          columns: columns2,
          defaultSortColumn: "",
          disableSort: true,
          checkButtonAriaLabel: `${name} row checkbox`
        }
      }
    ) });
  };
  const _onRenderFlightListItemColumn = (key, listName, isReadOnly, list, index, column, dropdownList) => {
    const { fieldName = "" } = column || {};
    if (!column || !fieldName || index === void 0)
      return null;
    const ndropdownList = _genFlightFormatsList(list[index]);
    return _onRenderUnmanagedListItemColumn(key, listName, isReadOnly, list, index, column, ndropdownList);
  };
  const _onRenderTimeStampItemColumn = (key, listName, isReadOnly, list, index, column, dropdownList) => {
    const { fieldName = "" } = column || {};
    if (!column || !fieldName || index === void 0)
      return null;
    return /* @__PURE__ */ jsxs(Stack, { tokens: { childrenGap: 10 }, children: [
      /* @__PURE__ */ jsx(
        SpecialColumnsField,
        {
          ariaLabel: listName,
          fieldName: `${listName}.[${index}].${fieldName}`,
          textFieldProps: {
            isReadOnly
          }
        }
      ),
      /* @__PURE__ */ jsx(
        CheckboxField,
        {
          disabled: isReadOnly,
          styles: { text: { whiteSpace: "normal" } },
          name: `${listName}.[${index}].NonNullable`,
          ariaLabel: "I agree to allow this column type to be set as non-nullable.",
          onRenderLabel: () => /* @__PURE__ */ jsxs("span", { children: [
            "I agree to allow this column type to be set as non-nullable.",
            " ",
            /* @__PURE__ */ jsx(
              ExternalLink,
              {
                rel: "noopener noreferrer",
                text: "Learn more",
                "aria-label": 'Learn more about "Non-Nullable"',
                href: "https://eng.ms/docs/products/experimentation-platform/docs/datasources/datacontract#timestamp-column",
                target: "_blank"
              }
            )
          ] })
        }
      )
    ] });
  };
  const _onRenderUnmanagedListItemColumn = (key, listName, isReadOnly, list, index, column, dropdownList) => {
    const { fieldName = "" } = column || {};
    if (!column || !fieldName || index === void 0)
      return null;
    switch (fieldName) {
      case "Format":
        return /* @__PURE__ */ jsx(
          SpecialColumnsDropdown,
          {
            index,
            fieldName: `${listName}.[${index}].Format`,
            formatOptions: dropdownList ? dropdownList : [],
            dropdownProps: {
              isReadOnly
            }
          }
        );
      default:
        return /* @__PURE__ */ jsx(
          SpecialColumnsField,
          {
            ariaLabel: listName,
            fieldName: `${listName}.[${index}].${fieldName}`,
            textFieldProps: {
              isReadOnly
            }
          }
        );
    }
  };
  const _genFlightFormatsList = (currentFlight) => {
    let options = [];
    let source = null;
    const flightFormatList = [...flightFormats];
    if ((currentFlight == null ? void 0 : currentFlight.Definition) && (currentFlight == null ? void 0 : currentFlight.Source) && (currentFlight == null ? void 0 : currentFlight.Example)) {
      if (!flightFormats.map((item) => item.Example).includes(currentFlight.Example)) {
        flightFormatList == null ? void 0 : flightFormatList.push({
          Source: currentFlight.Source,
          Definition: currentFlight.Definition,
          Example: currentFlight.Example
        });
      }
    }
    _.each(flightFormatList, (item, key) => {
      if (source === null || source !== item.Source) {
        source = item.Source;
        options.push({
          key: `${key} Header`,
          text: source != null ? source : "",
          itemType: 2,
          data: { Source: "", Definition: "", Example: "" }
        });
        options.push({
          key: item.Example,
          text: item.Example,
          data: {
            Source: item.Source,
            Definition: item.Definition,
            Example: item.Example
          }
        });
      } else if (source === item.Source) {
        options.push({
          key: item.Example,
          text: item.Example,
          data: {
            Source: item.Source,
            Definition: item.Definition,
            Example: item.Example
          }
        });
      }
    });
    return options;
  };
  const { randomizationListErrors, flightListErrors, timestampListErrors } = props;
  const randomizationErrors = typeof randomizationListErrors === "string" ? [randomizationListErrors] : [];
  const flightErrors = typeof flightListErrors === "string" ? [flightListErrors] : [];
  const timestampErrors = typeof timestampListErrors === "string" ? [timestampListErrors] : [];
  const columns = [
    {
      key: "ColumnName",
      name: "Column name",
      maxWidth: 280,
      minWidth: 280,
      fieldName: "ColumnName",
      data: "string"
    }
  ];
  if (showNGPColumnsInSpecialColumn(props.storageType)) {
    const ngpColumns = [
      {
        key: "NGPColumnTag",
        name: "NGP column tag code annotation",
        minWidth: 300,
        maxWidth: 500,
        fieldName: "NGPColumnTag",
        data: "string",
        onRenderHeader: (column) => {
          var _a2;
          return /* @__PURE__ */ jsxs("div", { children: [
            (_a2 = column == null ? void 0 : column.column.name) != null ? _a2 : "",
            /* @__PURE__ */ jsx(
              IconButton,
              {
                calloutProps: {
                  content: `For example: [Privacy.Subject.User.ObjectId(Column=#ColumnName#, Format=Privacy.Subject.User.ObjectId.AllowedFormat.Guid)]`
                },
                iconProps: { iconName: "Info" },
                ariaLabel: " NGP column tag Info"
              }
            )
          ] });
        },
        onRender: (item, index) => {
          return /* @__PURE__ */ jsx(
            SpecialColumnsField,
            {
              ariaLabel: "NGP column tag",
              fieldName: `randomizationList.[${index}].NGPColumnTag`,
              required: false,
              textFieldProps: {
                isReadOnly: false,
                description: "Provide the NGP column tag"
              }
            }
          );
        }
      },
      {
        key: "NGPStreamTag",
        name: "NGP stream tag code annotation",
        minWidth: 300,
        maxWidth: 500,
        fieldName: "NGPStreamTag",
        data: "string",
        onRenderHeader: (column) => {
          var _a2;
          return /* @__PURE__ */ jsxs("div", { children: [
            (_a2 = column == null ? void 0 : column.column.name) != null ? _a2 : "",
            /* @__PURE__ */ jsx(
              IconButton,
              {
                calloutProps: {
                  content: `For example: [Privacy.Asset.IntermediateEngineering]`
                },
                iconProps: { iconName: "Info" },
                ariaLabel: "NGP stream tag Info"
              }
            )
          ] });
        },
        onRender: (item, index) => /* @__PURE__ */ jsx(
          SpecialColumnsField,
          {
            ariaLabel: "NGP stream tag",
            fieldName: `randomizationList.[${index}].NGPStreamTag`,
            required: false,
            textFieldProps: {
              isReadOnly: false,
              description: "Provide the NGP stream tag"
            }
          }
        )
      }
    ];
    columns.push(...ngpColumns);
  }
  return /* @__PURE__ */ jsxs(StepContainer, { layout: StepLayouts.fullWidth, children: [
    !props.isUpdateDataSource && /* @__PURE__ */ jsx(FormHeading, { pageTitle: CreateStepTitle.SpecialColumns, children: "This is where you specify at least one assignment unit column, one flight column along with its format, and one timestamp column." }),
    /* @__PURE__ */ jsxs(FormSection, { children: [
      _onRenderUnmanagedList(
        "assignment unit columns",
        "Assignment unit column(s)",
        "randomizationList",
        randomizationErrors,
        props.randomizationList,
        selectionRandomizationUnit.current,
        columns,
        {
          ColumnName: "",
          NGPColumnTag: "",
          NGPStreamTag: ""
        },
        _onRenderUnmanagedListItemColumn
      ),
      _onRenderUnmanagedList(
        "flight columns",
        "Variant column(s)",
        "flightList",
        flightErrors,
        props.flightList,
        selectionFlight.current,
        [
          {
            key: "ColumnName",
            name: "Column name",
            minWidth: 280,
            maxWidth: 280,
            fieldName: "ColumnName",
            data: "string"
          },
          {
            key: "Format",
            name: "Format",
            minWidth: 280,
            fieldName: "Format",
            data: "string"
          }
        ],
        {
          ColumnName: "",
          Format: "",
          Source: "",
          Definition: "",
          Example: ""
        },
        _onRenderFlightListItemColumn
      ),
      _onRenderUnmanagedList(
        "timestamp columns",
        "Timestamp column(s)",
        "timestampList",
        timestampErrors,
        props.timestampList,
        selectionTimestamp.current,
        [
          {
            key: "ColumnName",
            name: "Column name",
            minWidth: 280,
            fieldName: "ColumnName",
            data: "string"
          }
        ],
        {
          ColumnName: "",
          NonNullable: false
        },
        _onRenderTimeStampItemColumn
      )
    ] })
  ] });
};
function DataLinkInfoComponent(props) {
  const pickerSuggestionsProps = {
    suggestionsContainerAriaLabel: "Suggested sample data sources",
    loadingText: "Search...",
    noResultsFoundText: ""
  };
  const onSampleDatasourceFilterChanged = (filter, selectedItems) => {
    if (!!filter) {
      const searchResult = DataSourceResource.getDataSourceList(props.workspaceId, filter, DataSourceTypes.Sample);
      const convertedReuslt = searchResult.then((r) => {
        if (!!r.getSuccessData().Items && r.getSuccessData().Items.length > 0) {
          return r.getSuccessData().Items.filter((item) => {
            return item.Name.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
          }).map((item) => {
            return {
              key: item.Name,
              name: item.Name
            };
          });
        } else {
          pickerSuggestionsProps.noResultsFoundText = "No result found";
          return [];
        }
      }).catch((e) => {
        Logger.error("Error while fetching sample data sources", e);
      });
      return convertedReuslt;
    } else {
      pickerSuggestionsProps.noResultsFoundText = "No result found";
      return [];
    }
  };
  return /* @__PURE__ */ jsxs(StepContainer$1, { children: [
    /* @__PURE__ */ jsxs(FormHeading$1, { pageTitle: CreateStepTitle.Links, children: [
      "Link a sample data for quick metric validation from this main data source.",
      " ",
      /* @__PURE__ */ jsx(LearnMoreLink, { "aria-label": "Learn more", href: "https://aka.ms/exp/docs/dsmsoverview" })
    ] }),
    /* @__PURE__ */ jsxs(FormSection$1, { children: [
      /* @__PURE__ */ jsx(
        TagPickerField$1,
        {
          name: "linkedSampleDataSource",
          label: "Data source to link",
          showSuggestions: true,
          labelProps: {
            iconProps: {
              calloutProps: {
                content: "Enter name or search for sample data source. The linked sample data source will be used for quick metric preview."
              }
            }
          },
          tagPickerProps: {
            ariaLabel: "Sample Datasource TagPicker",
            removeButtonAriaLabel: "Remove Selected Sample datasource",
            itemLimit: 1,
            selectedItems: props.formikProps.values.linkedSampleDataSource ? props.formikProps.values.linkedSampleDataSource.map((item) => {
              return {
                key: item,
                name: item
              };
            }) : [],
            onResolveSuggestions: onSampleDatasourceFilterChanged,
            resolveDelay: 300,
            pickerSuggestionsProps
          },
          required: false,
          disabled: !!props.isReadOnly
        }
      ),
      /* @__PURE__ */ jsx(
        TextField,
        {
          name: "linkComment",
          innerTextFieldProps: {
            ariaLabel: "Link Comment",
            label: "Comment",
            required: false,
            disabled: !!props.isReadOnly,
            multiline: true
          }
        }
      )
    ] })
  ] });
}
var CreateStepKey = /* @__PURE__ */ ((CreateStepKey2) => {
  CreateStepKey2["Basic"] = "basic";
  CreateStepKey2["Location"] = "location";
  CreateStepKey2["SpecicalColumns"] = "specialcolumns";
  CreateStepKey2["Parameters"] = "parameters";
  CreateStepKey2["Availability"] = "availability";
  CreateStepKey2["Profiling"] = "profiling";
  CreateStepKey2["Links"] = "links";
  return CreateStepKey2;
})(CreateStepKey || {});
var CreateStepTitle = /* @__PURE__ */ ((CreateStepTitle2) => {
  CreateStepTitle2["Basic"] = "Details";
  CreateStepTitle2["Location"] = "Data location";
  CreateStepTitle2["SpecialColumns"] = "Special columns";
  CreateStepTitle2["Parameters"] = "Parameters";
  CreateStepTitle2["Availability"] = "Dependency files";
  CreateStepTitle2["Profiling"] = "Data profiling";
  CreateStepTitle2["Links"] = "Links";
  return CreateStepTitle2;
})(CreateStepTitle || {});
const tabOrder = {
  [
    "basic"
    /* Basic */
  ]: 0,
  [
    "location"
    /* Location */
  ]: 1,
  [
    "specialcolumns"
    /* SpecicalColumns */
  ]: 2,
  [
    "parameters"
    /* Parameters */
  ]: 3,
  [
    "availability"
    /* Availability */
  ]: 4,
  [
    "profiling"
    /* Profiling */
  ]: 5,
  [
    "links"
    /* Links */
  ]: 6
};
const createStepProperties = (props, state, formikProps) => {
  const { errors = {}, setFieldValue, values } = formikProps || {};
  let tabProperties = {
    [
      "basic"
      /* Basic */
    ]: {
      key: "basic",
      title: "Details",
      isError: isErrorInTab("basic", errors, tabOrder),
      tabContent: /* @__PURE__ */ jsx(BasicInfoComponent$1, { formikProps })
    },
    [
      "location"
      /* Location */
    ]: {
      key: "location",
      title: "Data location",
      isError: isErrorInTab("location", errors, tabOrder),
      tabContent: /* @__PURE__ */ jsx(DataLocationInfoComponent, { formikProps, isCreate: true, isMIReadOnly: false })
    },
    [
      "specialcolumns"
      /* SpecicalColumns */
    ]: {
      key: "specialcolumns",
      title: "Special columns",
      isError: isErrorInTab("specialcolumns", errors, tabOrder),
      tabContent: /* @__PURE__ */ jsx(
        SpecialColumnsComponent,
        {
          workspaceId: props.workspaceId,
          storageType: (values == null ? void 0 : values.storageType) || "",
          randomizationList: (values == null ? void 0 : values.randomizationList) || [],
          randomizationListErrors: errors.randomizationList,
          flightList: (values == null ? void 0 : values.flightList) || [],
          flightListErrors: errors.flightList,
          timestampList: (values == null ? void 0 : values.timestampList) || [],
          timestampListErrors: errors.timestampList,
          setFieldValue
        }
      )
    },
    [
      "parameters"
      /* Parameters */
    ]: {
      key: "parameters",
      title: "Parameters",
      isError: isErrorInTab("parameters", errors, tabOrder),
      tabContent: /* @__PURE__ */ jsx(ParametersInfoComponent$1, { formikProps })
    },
    [
      "availability"
      /* Availability */
    ]: {
      key: "availability",
      title: "Dependency files",
      isError: isErrorInTab("availability", errors, tabOrder),
      tabContent: /* @__PURE__ */ jsx(AvailabilityStreamInfoComponent$1, { formikProps })
    }
  };
  if (EnvironmentService.releaseDSMSdataprofiling() && (values == null ? void 0 : values.storageType) === DataLocationStorageType.Cosmos) {
    tabProperties = __spreadProps(__spreadValues({}, tabProperties), {
      [
        "profiling"
        /* Profiling */
      ]: {
        key: "profiling",
        title: "Data profiling",
        isError: isErrorInTab("profiling", errors, tabOrder),
        tabContent: /* @__PURE__ */ jsx(
          DataProfilingComponent,
          {
            isEnableProfiling: (values == null ? void 0 : values.isEnableProfiling) || false,
            profilingFrequency: (values == null ? void 0 : values.profilingFrequency) || ProfilingOptions.Manual
          }
        )
      }
    });
  }
  let keyOrder = [
    "basic",
    "location",
    "specialcolumns",
    "parameters",
    "availability"
    /* Availability */
  ];
  if (EnvironmentService.releaseDSMSdataprofiling() && (values == null ? void 0 : values.storageType) === DataLocationStorageType.Cosmos) {
    keyOrder = [
      ...keyOrder,
      "profiling"
      /* Profiling */
    ];
  }
  if (EnvironmentService.enableSampleDataSource()) {
    tabProperties = __spreadProps(__spreadValues({}, tabProperties), {
      [
        "links"
        /* Links */
      ]: {
        key: "links",
        title: "Links",
        isError: isErrorInTab("links", errors, tabOrder),
        tabContent: /* @__PURE__ */ jsx(
          DataLinkInfoComponent,
          {
            workspaceId: props.workspaceId,
            formikProps,
            isReadOnly: !(values == null ? void 0 : values.dataSourceType) || values.dataSourceType === DataSourceTypes.Sample
          }
        )
      }
    });
    keyOrder = [
      ...keyOrder,
      "links"
      /* Links */
    ];
  }
  return { stepProperties: keyOrder.map((k) => tabProperties[k]) };
};
const isErrorInTab = (createStepKey, errors, tabOrder2) => {
  switch (tabOrder2[createStepKey]) {
    case tabOrder2[
      "basic"
      /* Basic */
    ]:
      if (!!errors.name || !!errors.isUTC || !!errors.owners || !!errors.subscribers || EnvironmentService.enableSampleDataSource() && !!errors.dataSourceType) {
        return true;
      }
      break;
    case tabOrder2[
      "location"
      /* Location */
    ]:
      if (!!errors.storageType || !!errors.storageList || !!errors.storageMTList || !!errors.retentionDays) {
        return true;
      }
      break;
    case tabOrder2[
      "specialcolumns"
      /* SpecicalColumns */
    ]:
      if (!!errors.randomizationList || !!errors.flightList || !!errors.timestampList) {
        return true;
      }
      break;
    case tabOrder2[
      "parameters"
      /* Parameters */
    ]:
      if (!!errors.parameterList) {
        return true;
      }
      break;
    case tabOrder2[
      "availability"
      /* Availability */
    ]:
      if (!!errors.streamList) {
        return true;
      }
      break;
    case tabOrder2[
      "profiling"
      /* Profiling */
    ]:
      return false;
    case tabOrder2[
      "links"
      /* Links */
    ]:
      return false;
  }
  return false;
};
class DataProfilingChoiceGroupComponent extends React.Component {
  render() {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        CheckboxField$1,
        {
          name: "isEnableProfiling",
          ariaLabel: "I consent to Azure Experimentation Studio running a test profiling job on my data using the virtual cluster in which the data source is located.",
          defaultChecked: this.props.isEnableProfiling,
          checked: this.props.isEnableProfiling,
          isReadOnly: !!this.props.isReadOnly,
          label: "I consent to Azure Experimentation Studio running a test profiling job on my data using the virtual cluster in which the data source is located."
        }
      ),
      this.props.isEnableProfiling && /* @__PURE__ */ jsx(
        ChoiceGroupField,
        {
          name: "profilingFrequency",
          label: "Select the profiling frequency",
          ariaLabel: "Select the profiling frequency",
          isReadOnly: !!this.props.isReadOnly,
          options: [
            { key: ProfilingOptions.Manual, text: "Manual (default)", ariaLabel: "Manual (default)" },
            { key: ProfilingOptions.Daily, text: "Daily", ariaLabel: "Daily" },
            { key: ProfilingOptions.Weekly, text: "Weekly", ariaLabel: "Weekly" }
          ],
          defaultSelectedKey: "Manual",
          required: true,
          labelProps: {
            iconProps: {
              calloutProps: {
                content: "Please select the frequency at which you would like the column(s) profiled. The default is manual, which means you will need to trigger the profiling job manually, when needed. If you would profiling to be done automatically on a regular basis, you have the option to select either a daily or weekly frequency."
              }
            }
          }
        }
      )
    ] });
  }
}
var ProfilingOptions = /* @__PURE__ */ ((ProfilingOptions2) => {
  ProfilingOptions2["Manual"] = "Manual";
  ProfilingOptions2["Daily"] = "Daily";
  ProfilingOptions2["Weekly"] = "Weekly";
  return ProfilingOptions2;
})(ProfilingOptions || {});
const mapStateToProps = (state, props) => {
};
const mapDispatchToProps = {};
class DataProfilingComponent extends React.Component {
  render() {
    return /* @__PURE__ */ jsxs(StepContainer, { children: [
      /* @__PURE__ */ jsxs(FormHeading, { pageTitle: CreateStepTitle.Profiling, children: [
        "In this section, we seek your consent to profile a subset of columns in your data source to ensure that these columns do not cause any downstream issues with scorecard generation. If you provide us your consent, we will run a test profiling job and notify you about its cost. You will then have the option to modify the frequency of profiling, which is set to manual by default. If we determine any additional columns need profiling, we will seek your consent to profile, and if granted, determine cost and notify you. At each such instance, you can update the frequency of profiling as desired.",
        /* @__PURE__ */ jsx("br", {}),
        /* @__PURE__ */ jsx("br", {}),
        "We strongly recommend that you provide us your consent. If you do not, Azure Experimentation Studio will be unable to detect data issues beforehand, that may lead to scorecard failures."
      ] }),
      /* @__PURE__ */ jsx(FormSection, { children: /* @__PURE__ */ jsx(
        DataProfilingChoiceGroupComponent,
        {
          isEnableProfiling: this.props.isEnableProfiling,
          isReadOnly: !!this.props.isReadOnly
        }
      ) })
    ] });
  }
}
const DataProfilingComponent$1 = connect(
  mapStateToProps,
  mapDispatchToProps
)(DataProfilingComponent);
var dataSourceCreateComponentsName = /* @__PURE__ */ ((dataSourceCreateComponentsName2) => {
  dataSourceCreateComponentsName2["basicinfo"] = "basicinfo";
  dataSourceCreateComponentsName2["datalocationinfo"] = "datalocationinfo";
  dataSourceCreateComponentsName2["specialcolumns"] = "specialcolumns";
  dataSourceCreateComponentsName2["parametersinfo"] = "parametersinfo";
  dataSourceCreateComponentsName2["availabilitystreaminfo"] = "availabilitystreaminfo";
  return dataSourceCreateComponentsName2;
})(dataSourceCreateComponentsName || {});
const getValidateCosmosDateTimeDiff = (start, end) => {
  if (start && end) {
    const startNumber = Number.parseInt(start);
    const endNumber = Number.parseInt(end);
    if (isNaN(startNumber)) {
      return "StartDate offset must be less than 0.";
    }
    if (isNaN(endNumber)) {
      return "EndDate offset must be less than 0.";
    }
    if (startNumber >= 0) {
      return "StartDate offset must be less than 0.";
    }
    if (startNumber < -365) {
      return "StartDate offset cannot be less than -365.";
    }
    if (endNumber >= 0) {
      return "EndDate offset must be less than 0.";
    }
    if (startNumber > endNumber) {
      return "EndDate offset cannot be less than StartDate offset.";
    }
    if (startNumber < 0 && startNumber >= -365 && endNumber < 0 && endNumber - startNumber <= 5 && endNumber - startNumber >= 0) {
      return "";
    } else {
      return "StartDate and EndDate offsets are not allowed to differ by more than 5.";
    }
  } else {
    return "";
  }
};
var dataSourceCreateComponentsName = /* @__PURE__ */ ((dataSourceCreateComponentsName2) => {
  dataSourceCreateComponentsName2["retentiondays"] = "retentiondays";
  dataSourceCreateComponentsName2["url"] = "url";
  dataSourceCreateComponentsName2["cluster"] = "cluster";
  dataSourceCreateComponentsName2["system.string"] = "system.string";
  dataSourceCreateComponentsName2["system.boolean"] = "system.boolean";
  dataSourceCreateComponentsName2["system.int32"] = "system.int32";
  dataSourceCreateComponentsName2["cosmosdatenumberend"] = "cosmosdatenumberend";
  dataSourceCreateComponentsName2["cosmosdatenumberstart"] = "cosmosdatenumberstart";
  dataSourceCreateComponentsName2["system.double"] = "system.double";
  dataSourceCreateComponentsName2["system.int64"] = "system.int64";
  return dataSourceCreateComponentsName2;
})(dataSourceCreateComponentsName || {});
const getValidateMessage = (name, value, IsADLSGen2AndUsingSP) => {
  if (!value || "" === value.trim()) {
    if (IsADLSGen2AndUsingSP) {
      switch (name.toLowerCase()) {
        case "url":
          return "";
        case "secretname":
          return "";
        default:
          return "Required";
      }
    }
    switch (name.toLowerCase()) {
      case "retentiondays":
        return "";
      case "retentiondayserrormsg":
        return "";
      default:
        return "Required";
    }
  }
  switch (name.toLowerCase()) {
    case "retentiondays":
      const isValueValid = !isNaN(Number(value)) || value === "";
      let errorMessage = "";
      if (!isValueValid) {
        errorMessage = "Please enter a number";
      } else if (Number(value) <= 0) {
        errorMessage = "The valid data period must be a positive integer.";
      }
      return errorMessage;
    case "url":
      try {
        new URL(value);
      } catch (_2) {
        return "Require URL";
      }
      return "";
    case "cluster":
      if (!validateCluster(value.toLowerCase())) {
        return "For example vc://cosmos{ClusterNumber} or https://[aad].{ClusterName}.osdinfra.net/cosmos";
      } else {
        return "";
      }
    case "system.string":
      if (!validateParameter(value, name)) {
        return "String should be double quoted";
      } else {
        return "";
      }
    case "system.boolean":
      if (!validateParameter(value, name)) {
        return "Require bool type";
      } else {
        return "";
      }
    case "system.int32":
    case "system.int64":
      if (!validateParameter(value, name)) {
        return "Require integer type";
      } else {
        return "";
      }
    case "system.double":
      if (!validateParameter(value, name)) {
        return "Require double type";
      } else {
        return "";
      }
    case "cosmosdatenumberstart":
      if (!validateParameter(value, name)) {
        return "StartDate offset must be less than 0.";
      } else {
        return "";
      }
    case "cosmosdatenumberend":
      if (!validateParameter(value, name)) {
        return "EndDate offset must be less than 0.";
      } else {
        return "";
      }
    default:
      return "";
  }
};
const validateCluster = (cluster) => {
  cluster = cluster.toLowerCase();
  return /^https:\/\/(aad\.)?.*\.osdinfra\.net\/cosmos$/.test(cluster) || /^vc:\/\/cosmos[0-9]+(\/)?$/.test(cluster);
};
const validateParameter = (parameter, type) => {
  if (!parameter || "" === parameter.trim()) {
    return false;
  }
  switch (type.toLocaleLowerCase()) {
    case "system.string":
      return /^".*"+$/.test(parameter);
    case "system.int32":
    case "system.int64":
      return /^[-+]?[0-9]+$/.test(parameter);
    case "cosmosdatenumber":
      return /^[-][0-9]+$/.test(parameter) && Number.parseInt(parameter) < 0 && Number.parseInt(parameter) >= -365;
    case "system.double":
      return /^([-+]?\d+)(\.\d+)?$/.test(parameter);
    case "system.boolean":
    default:
      return true;
  }
};
const getPlaceHolder = (component, name, storageType = "") => {
  var _a;
  const placeholderDict = {
    ["basicinfo_owners"]: "Tab separated list of user aliases",
    ["basicinfo_isutc"]: "Please select the time zone is UTC or not",
    // DataLocationInfo
    ["datalocationinfo_cosmos_cluster"]: "For example vc://cosmos09 or https://cosmos09.osdinfra.net/cosmos",
    ["datalocationinfo_cosmos_vc"]: "Provide the VC name",
    ["datalocationinfo_cosmos_datapath"]: "Provide the data path",
    ["datalocationinfo_mt_datapath"]: "For example /Event/eventYear={YYYY}/eventMonth={MM}/eventDay={DD}/*.parquet",
    ["datalocationinfo_azureblob_datapath"]: "For example /Event/eventYear={YYYY}/eventMonth={MM}/eventDay={DD}/*.parquet",
    ["datalocationinfo_adlsgen2_datapath"]: "For example /Event/eventYear={YYYY}/eventMonth={MM}/eventDay={DD}/*.parquet",
    ["datalocationinfo_adlsgen2_url"]: "Provide the ADLS Gen2 key vault URL",
    ["datalocationinfo_adlsgen2_secretname"]: "Provide the ADLS Gen2 Secret Name",
    ["datalocationinfo_datatype"]: "Please select the data type",
    // SpecialColumns
    ["specialcolumns_columnname"]: "Enter column name",
    ["specialcolumns_format"]: "Select flight format",
    // ParametersInfo
    ["parametersinfo_name"]: name,
    ["parametersinfo_type"]: name,
    ["parametersinfo_value"]: "Parameter value",
    ["parametersinfo_samplevalue"]: "Parameter sample value",
    // Availability Stream Info
    ["availabilitystreaminfo_cluster"]: "For example https://cosmos09.osdinfra.net/cosmos",
    ["availabilitystreaminfo_vc"]: "searchDMProd",
    ["availabilitystreaminfo_datapath"]: "For example /shares/bus.prod/local/office/Aggregated/Datasets/Public/FlightAssignment/EXO/EXOVariantConfig/%Y/%m/EXOVariantConfigCompact_%Y_%m_%d.ss",
    ["datalocationinfo_mt_region"]: "E.g.: CO4-3",
    ["datalocationinfo_mt_endpoint"]: "E.g.: CO4-3",
    ["datalocationinfo_mt_serviceprincipalname"]: "Please select your service principal"
  };
  let key = component;
  if (storageType) {
    key += "_" + storageType;
  }
  key = (key + "_" + name).toLowerCase();
  if (placeholderDict[key]) {
    return placeholderDict[key];
  }
  const displayStorageTypeDict = {
    [DataLocationStorageType.ADLSGen2]: "ADLS Gen2",
    [DataLocationStorageType.AzureBlob]: "Azure Blob"
  };
  const displayStorageType = (_a = displayStorageTypeDict[storageType]) != null ? _a : storageType;
  switch (name) {
    case "DataPath":
      return "For example /Event/eventYear={YYYY}/eventMonth={MM}/eventDay={DD}/*.parquet";
    case "StorageAccount":
      return `Provide the ${displayStorageType} storage account`;
    case "Container":
      return `Provide the ${displayStorageType} storage container`;
    default:
      return `Provide a descriptive ${name}`;
  }
};
var DataType = /* @__PURE__ */ ((DataType2) => {
  DataType2["CosmosCosmosView"] = "Cosmos-CosmosView";
  DataType2["AzureBlobParquet"] = "AzureBlob-Parquet";
  DataType2["ADLSGen2Parquet"] = "ADLSGen2-Parquet";
  DataType2["ADLSGen2CosmosView"] = "ADLSGen2-CosmosView";
  DataType2["MTParquet"] = "MT-Parquet";
  return DataType2;
})(DataType || {});
var StorageType = /* @__PURE__ */ ((StorageType2) => {
  StorageType2["Cosmos"] = "Cosmos";
  StorageType2["AzureBlob"] = "AzureBlob";
  StorageType2["ADLSGen2"] = "ADLSGen2";
  StorageType2["ADLSGen2CosmosView"] = "ADLSGen2CosmosView";
  StorageType2["MT"] = "MT";
  return StorageType2;
})(StorageType || {});
var FileFormat = /* @__PURE__ */ ((FileFormat2) => {
  FileFormat2["CosmosView"] = "CosmosView";
  FileFormat2["Parquet"] = "Parquet";
  return FileFormat2;
})(FileFormat || {});
const dataSourceDataTypeList = [
  {
    LocationProperties: {
      DataPath: "String",
      VC: "String",
      Cluster: "String"
    },
    DataType: "Cosmos-CosmosView",
    StorageType: "Cosmos",
    FileFormat: "CosmosView"
    /* CosmosView */
  },
  {
    LocationProperties: {
      DataPath: "String",
      StorageAccount: "String",
      Container: "String"
    },
    DataType: "AzureBlob-Parquet",
    StorageType: "AzureBlob",
    FileFormat: "Parquet"
    /* Parquet */
  },
  {
    LocationProperties: {
      DataPath: "String",
      StorageAccount: "String",
      Container: "String",
      KeyVaultAuthentication: {
        Url: "String",
        SecretName: "String"
      }
      //ServicePrincipalName: 'String'
    },
    DataType: "ADLSGen2-Parquet",
    StorageType: "ADLSGen2",
    FileFormat: "Parquet"
    /* Parquet */
  },
  {
    LocationProperties: {
      DataPath: "String",
      StorageAccount: "String",
      Container: "String"
    },
    DataType: "ADLSGen2-CosmosView",
    StorageType: "ADLSGen2CosmosView",
    FileFormat: "CosmosView"
    /* CosmosView */
  },
  {
    LocationProperties: {
      EndPoint: "String",
      DataPath: "String",
      Region: "String",
      SubCluster: "String"
    },
    DataType: "MT-Parquet",
    StorageType: "MT",
    FileFormat: "Parquet"
    /* Parquet */
  }
];
const sampleDataSourceDataTypeList = [
  {
    LocationProperties: {
      DataPath: "String",
      VC: "String",
      Cluster: "String"
    },
    DataType: "Cosmos-CosmosView",
    StorageType: "Cosmos",
    FileFormat: "CosmosView"
    /* CosmosView */
  },
  {
    LocationProperties: {
      DataPath: "String",
      StorageAccount: "String",
      Container: "String"
    },
    DataType: "AzureBlob-Parquet",
    StorageType: "AzureBlob",
    FileFormat: "Parquet"
    /* Parquet */
  },
  {
    LocationProperties: {
      DataPath: "String",
      StorageAccount: "String",
      Container: "String",
      KeyVaultAuthentication: {
        Url: "String",
        SecretName: "String"
      }
    },
    DataType: "ADLSGen2-Parquet",
    StorageType: "ADLSGen2",
    FileFormat: "Parquet"
    /* Parquet */
  }
];
const getFileFormat = (props) => {
  let FileFormat2 = "";
  let storageType = props.storageType;
  _.each(dataSourceDataTypeList, (item, key) => {
    if (item.StorageType === storageType) {
      FileFormat2 = item.FileFormat;
    }
  });
  return FileFormat2;
};
const getDataSourceTypeLocation = (props) => {
  let locationProperties = {};
  let storageType = props.storageType;
  _.each(dataSourceDataTypeList, (item, key) => {
    if (item.StorageType === storageType && props.storageList) {
      locationProperties = {
        DataPath: props.storageList.DataPath,
        EndPoint: props.storageList.EndPoint,
        VC: props.storageList.VC,
        Cluster: props.storageList.Cluster,
        StorageAccount: props.storageList.StorageAccount,
        Container: props.storageList.Container,
        KeyVaultAuthentication: props.storageType === DataLocationStorageType.ADLSGen2 && (props.authenticationType === AuthenticationType.Secret || !props.authenticationId && !props.managedIdentityId) ? {
          Url: props.storageList.Url,
          SecretName: props.storageList.SecretName
        } : void 0,
        ServicePrincipalName: props.storageList.ServicePrincipalName
      };
    }
  });
  return locationProperties;
};
var CosomosViewDefaultDate = /* @__PURE__ */ ((CosomosViewDefaultDate2) => {
  CosomosViewDefaultDate2["Start"] = '"#Start#"';
  CosomosViewDefaultDate2["End"] = '"#End#"';
  return CosomosViewDefaultDate2;
})(CosomosViewDefaultDate || {});
var CosmosViewDefaultDatePlaceholder = /* @__PURE__ */ ((CosmosViewDefaultDatePlaceholder2) => {
  CosmosViewDefaultDatePlaceholder2["Start"] = "e.g. StartDate";
  CosmosViewDefaultDatePlaceholder2["End"] = "e.g. EndDate";
  return CosmosViewDefaultDatePlaceholder2;
})(CosmosViewDefaultDatePlaceholder || {});
const getCosmosViewStartEndDefaultValue = (name) => {
  if (compareIgnoreCase("start", name)) {
    return "-12";
  } else {
    return "-11";
  }
};
const getCosmosViewDefaultParameter = () => {
  return [
    {
      Name: "",
      Type: "System.String",
      Value: '"#Start#"',
      SampleValue: getCosmosViewStartEndDefaultValue("start"),
      delete: notDeleteKey,
      required: {
        Name: "Required",
        Type: "",
        Value: "",
        SampleValue: ""
      },
      placeholder: {
        Name: "e.g. StartDate",
        Value: 'eg: "2020-01-01"',
        SampleValue: 'eg: today("-12")'
      }
    },
    {
      Name: "",
      Type: "System.String",
      Value: '"#End#"',
      SampleValue: getCosmosViewStartEndDefaultValue("end"),
      delete: notDeleteKey,
      required: {
        Name: "Required",
        Type: "",
        Value: "",
        SampleValue: ""
      },
      placeholder: {
        Name: "e.g. EndDate",
        Value: 'eg: "2020-01-01"',
        SampleValue: 'eg: today("-11")'
      }
    }
  ];
};
const genErrorMessageDataLocationInfo = (storageList) => {
  if (!storageList || Object.getOwnPropertyNames(storageList).length <= 0) {
    return {
      DataPath: "",
      VC: "",
      Cluster: ""
    };
  } else {
    return storageList;
  }
};
const genErrorMessageParameterInfo = (parameters, IsCosmosType) => {
  if (parameters && parameters.length > 0) {
    _.each(parameters, (item, key) => {
      if (item.Name === "") {
        item.required.Name = "Required";
      }
      if (item.Type === "") {
        item.required.Type = "Required";
      }
      if (item.Value === "") {
        item.required.Value = "Required";
      } else {
        if (!IsCosmosType && item.Type === parameterType.SystemString) {
          item.required.Value = "";
        } else {
          item.required.Value = getValidateMessage(item.Type, item.Value);
        }
      }
      if (item.SampleValue !== "") {
        if (IsCosmosType && (key === 0 || key === 1)) {
          item.required.SampleValue = getValidateMessage(
            parameterType.CosmosDateNumber + key ? "start" : "end",
            item.SampleValue
          );
        } else {
          if (!IsCosmosType && item.Type === parameterType.SystemString) {
            item.required.Value = "";
          } else {
            item.required.SampleValue = getValidateMessage(item.Type, item.SampleValue);
          }
        }
      }
      parameters = [
        ...parameters.slice(0, key),
        __spreadValues({}, item),
        ...parameters.slice(key + 1)
      ];
    });
  }
  return parameters;
};
const genErrorMessageAvailabilityStreamInfo = (streams) => {
  if (streams && streams.length > 0) {
    _.each(streams, (item, key) => {
      if (item.DataPath === "") {
        item.required.DataPath = "Required";
      }
      streams = [
        ...streams.slice(0, key),
        __spreadValues({}, item),
        ...streams.slice(key + 1)
      ];
    });
  }
  return streams;
};
const genErrorMessageDataSourceName = (dataSourceName) => {
  if (dataSourceName) {
    const dataSourceNameValueRegex = /^([\w][\w ]{0,126}[\w]$)|^([\w]{1,128})$/;
    if (!dataSourceNameValueRegex.test(dataSourceName)) {
      return "Alphanumeric and underscore allowed.";
    }
  } else {
    return "Required";
  }
  return "";
};
const genErrorMessageOverrideDataSourceName = (primaryDataSourceName, dataSourceName) => {
  if (dataSourceName && primaryDataSourceName) {
    const dataSourceOverrideNameValueRegex = /^([\w-][\w- ]{0,126}[\w-]$)|^([\w-]{1,128})$/;
    const error = !dataSourceOverrideNameValueRegex.test(primaryDataSourceName + "-" + dataSourceName) ? "Alphanumeric, hyphen and underscore allowed." : "";
    if (!!error) {
      return error;
    }
  } else {
    return "Required";
  }
  return "";
};
const validateBasicInfo = (values, workspaceId) => {
  const errors = {};
  if (genErrorMessageDataSourceName(values.name)) {
    errors.name = genErrorMessageDataSourceName(values.name);
  }
  if (!values.isUTC) {
    errors.isUTC = "Required";
  }
  if (EnvironmentService.enableSampleDataSource() && !values.dataSourceType) {
    errors.dataSourceType = "Required";
  }
  if (isClassicWorkspaceById(workspaceId) && (!values.owners || values.owners.length === 0)) {
    errors.owners = "Need at least 1 owner";
  }
  return errors;
};
const validateOverrideBasicInfo = (FromName, values) => {
  const errors = {};
  if (genErrorMessageOverrideDataSourceName(FromName, values.name)) {
    errors.name = genErrorMessageOverrideDataSourceName(FromName, values.name);
  }
  return errors;
};
const isURLValid = (url) => {
  try {
    new URL(url);
  } catch (_2) {
    return "URL format is invalid";
  }
  return "";
};
const validateDataLocationInfo = (values, existingErrors, workspaceId, isCreate) => {
  var _a;
  if (!values.storageType) {
    existingErrors.storageType = "Required";
  }
  if (values.storageType === DataLocationStorageType.MT) {
    if (!values.storageMTList || values.storageMTList.length <= 0) {
      existingErrors.storageMTList = "Required";
    } else {
      _.each(MTLocation[0].required, (item, key) => {
        if (!values.storageMTList[0][key]) {
          existingErrors.storageMTList = "Required";
        }
      });
    }
  } else {
    if (!values.storageList || Object.getOwnPropertyNames(values.storageList).length <= 0) {
      existingErrors.storageList = {
        DataPath: "Required"
      };
    } else {
      _.each(values.storageList, (item, key) => {
        if (key.toLowerCase() === "url") {
          if (values.storageType === DataLocationStorageType.ADLSGen2) {
            if (values == null ? void 0 : values.authenticationType) {
              if (showMSIOption(workspaceId) && (values == null ? void 0 : values.authenticationType) === AuthenticationType.ManagedIdentity) {
                if (!values.managedIdentityId) {
                  existingErrors.storageList = {
                    ManagedIdentityName: "Required"
                  };
                }
              } else if ((values == null ? void 0 : values.authenticationType) === AuthenticationType.ServicePrincipal) {
                if (!values.authenticationId) {
                  existingErrors.storageList = {
                    ServicePrincipalName: "Required"
                  };
                }
              } else {
                if (!item) {
                  existingErrors.storageList = {
                    Url: "Required"
                  };
                } else if (isURLValid(item)) {
                  existingErrors.storageList = {
                    Url: isURLValid(item)
                  };
                }
              }
            } else {
              if (isCreate && showMSIOption(workspaceId) && (values == null ? void 0 : values.managedIdentityId) === void 0) {
                if (!values.managedIdentityId) {
                  existingErrors.storageList = {
                    ManagedIdentityName: "Required"
                  };
                } else {
                  if (!item) {
                    existingErrors.storageList = {
                      Url: "Required"
                    };
                  } else if (isURLValid(item)) {
                    existingErrors.storageList = {
                      Url: isURLValid(item)
                    };
                  }
                }
              }
            }
          } else {
            if (!item) {
              existingErrors.storageList = {
                Url: "Required"
              };
            } else if (isURLValid(item)) {
              existingErrors.storageList = {
                Url: isURLValid(item)
              };
            }
          }
        } else if (key.toLowerCase() === "secretname") {
          if (values.storageType === DataLocationStorageType.ADLSGen2) {
            if (showMSIOption(workspaceId) && (values == null ? void 0 : values.authenticationType) === AuthenticationType.ManagedIdentity) {
              if (!values.managedIdentityId) {
                existingErrors.storageList = {
                  ManagedIdentityName: "Required"
                };
              }
            } else if (values == null ? void 0 : values.authenticationType) {
              if ((values == null ? void 0 : values.authenticationType) === AuthenticationType.ServicePrincipal) {
                if (!values.authenticationId) {
                  existingErrors.storageList = {
                    ServicePrincipalName: "Required"
                  };
                }
              } else {
                if (!item) {
                  existingErrors.storageList = {
                    SecretName: "Required"
                  };
                }
              }
            } else {
              if (isCreate && showMSIOption(workspaceId) && (values == null ? void 0 : values.managedIdentityId) === void 0) {
                if (!values.managedIdentityId) {
                  existingErrors.storageList = {
                    ManagedIdentityName: "Required"
                  };
                } else {
                  if (!item) {
                    existingErrors.storageList = {
                      SecretName: "Required"
                    };
                  }
                }
              }
            }
          } else {
            if (!item) {
              existingErrors.storageList = {
                SecretName: "Required"
              };
            }
          }
        } else if (!item) {
          existingErrors.storageList = {
            DataPath: "Required"
          };
        } else {
          if (key.toLowerCase() === "cluster" && !validateCluster(item)) {
            existingErrors.storageList = {
              Cluster: "Required"
            };
          }
        }
      });
    }
  }
  if (values.storageType === DataLocationStorageType.AzureBlob || values.storageType === DataLocationStorageType.Cosmos && isCreate) {
    if (showMSIOption(workspaceId) && (!values.authenticationType || values.authenticationType === AuthenticationType.ManagedIdentity) && !values.managedIdentityId) {
      existingErrors.storageList = {
        ManagedIdentityName: "Required"
      };
    }
  } else if ((values.storageType === DataLocationStorageType.ADLSGen2CosmosView || values.storageType === DataLocationStorageType.ADLSGen2) && isCreate) {
    if (showMSIOption(workspaceId)) {
      if ((!values.authenticationType || values.authenticationType === AuthenticationType.ManagedIdentity) && !values.managedIdentityId) {
        existingErrors.storageList = {
          ManagedIdentityName: "Required"
        };
      } else if (values.authenticationType === AuthenticationType.ServicePrincipal && !values.authenticationId) {
        existingErrors.storageList = {
          ServicePrincipalName: "Required"
        };
      }
    } else {
      if ((!values.authenticationType || values.authenticationType === AuthenticationType.ServicePrincipal) && !values.authenticationId) {
        existingErrors.storageList = {
          ServicePrincipalName: "Required"
        };
      }
    }
  }
  const retentionDays = Number(values.retentionDays);
  if (values.retentionDays && isNaN(retentionDays)) {
    existingErrors.retentionDays = "Please enter a valid number";
  } else if (retentionDays < 0) {
    existingErrors.retentionDays = "The valid data period must be a positive integer.";
  }
  const retentionErrorMsg = (_a = values.retentionErrorMsg) != null ? _a : "";
  if ((retentionErrorMsg == null ? void 0 : retentionErrorMsg.length) > 2048) {
    existingErrors.retentionErrorMsg = "The length of the message must be less than 2048 characters.";
  }
  return existingErrors;
};
const genSepcialColumnsDict = (values) => {
  let dict = {};
  dict = _.countBy([...values.randomizationList, ...values.flightList, ...values.timestampList], (i) => i.ColumnName);
  return dict;
};
const checkMiddleBrackets = (value) => {
  let frontBracketList = [];
  for (const char of value) {
    if (char === "[") {
      if (frontBracketList.length === 0) {
        frontBracketList.push("[");
      } else {
        return false;
      }
    } else if (char === "]") {
      if (frontBracketList.length === 1) {
        frontBracketList.pop();
      } else {
        return false;
      }
    }
  }
  return frontBracketList.length === 0;
};
const errorDuplicateSpecialColumn = "Column with this name is already defined.";
const validateSpecialColumnsInfo = (values, existingErrors, initialValues) => {
  let hasErrors = false;
  const dict = genSepcialColumnsDict(values);
  if (values.randomizationList && values.randomizationList.length > 0) {
    const randomizationListErrors = _.map(
      values.randomizationList,
      (randomization, index) => {
        var _a, _b, _c, _d, _e;
        const error = {};
        if (((_b = (_a = values.dataContractErrorDetails) == null ? void 0 : _a.AssignmentUnits[index]) == null ? void 0 : _b.Error) && values.randomizationList[index].ColumnName === initialValues.randomizationList[index].ColumnName && _.trim((_c = values.dataContractErrorDetails) == null ? void 0 : _c.AssignmentUnits[index].Error) !== errorDuplicateSpecialColumn) {
          error.ColumnName = (_d = values.dataContractErrorDetails) == null ? void 0 : _d.AssignmentUnits[index].Error;
        }
        if (_.isEmpty(randomization.ColumnName)) {
          error.ColumnName = "Column name must not be empty.";
        }
        if (randomization.NGPColumnTag) {
          if (new RegExp(/\[|\]/).test(randomization.NGPColumnTag) && ((_e = randomization.NGPColumnTag.match(/(\[((?!\[).)*#ColumnName#((?!\]).)*\])+/g)) != null ? _e : []).join("").length !== randomization.NGPColumnTag.length)
            error.NGPColumnTag = 'every NGP Column tag should contain "#ColumnName#"';
          else if (!randomization.NGPColumnTag.includes("#ColumnName#"))
            error.NGPColumnTag = 'NGP Column tag should contain "#ColumnName#"';
        }
        if (randomization.NGPStreamTag && !checkMiddleBrackets(randomization.NGPStreamTag)) {
          error.NGPStreamTag = "The brackets not match";
        }
        if (randomization.ColumnName && dict[randomization.ColumnName] && dict[randomization.ColumnName] >= 2) {
          error.ColumnName = errorDuplicateSpecialColumn;
        }
        hasErrors = !_.isEmpty(error) ? true : hasErrors;
        return error;
      }
    );
    if (hasErrors && !!randomizationListErrors) {
      existingErrors = __spreadProps(__spreadValues({}, existingErrors), {
        randomizationList: randomizationListErrors
      });
    }
  } else {
    existingErrors.randomizationList = "Must create at least one assignment unit column";
  }
  if (values.flightList && values.flightList.length > 0) {
    const flightListErrors = _.map(values.flightList, (flight, index) => {
      var _a, _b, _c, _d;
      const error = {};
      if (((_b = (_a = values.dataContractErrorDetails) == null ? void 0 : _a.Flight[index]) == null ? void 0 : _b.Error) && values.flightList[index].ColumnName === initialValues.flightList[index].ColumnName && _.trim((_c = values.dataContractErrorDetails) == null ? void 0 : _c.Flight[index].Error) !== errorDuplicateSpecialColumn) {
        error.ColumnName = (_d = values.dataContractErrorDetails) == null ? void 0 : _d.Flight[index].Error;
      }
      if (_.isEmpty(flight.ColumnName)) {
        error.ColumnName = "Column name must not be empty.";
      }
      if (_.isEmpty(flight.Format)) {
        error.Format = "Format must not be empty.";
      }
      if (flight.ColumnName && dict[flight.ColumnName] && dict[flight.ColumnName] >= 2) {
        error.ColumnName = errorDuplicateSpecialColumn;
      }
      hasErrors = !_.isEmpty(error) ? true : hasErrors;
      return error;
    });
    if (hasErrors && !!flightListErrors) {
      existingErrors = __spreadProps(__spreadValues({}, existingErrors), {
        flightList: flightListErrors
      });
    }
  } else {
    existingErrors.flightList = "Must create at least one flight column";
  }
  if (values.timestampList && values.timestampList.length > 0) {
    const timestampListErrors = _.map(values.timestampList, (timestamp, index) => {
      var _a, _b, _c, _d;
      const error = {};
      if (((_b = (_a = values.dataContractErrorDetails) == null ? void 0 : _a.TimeStamp[index]) == null ? void 0 : _b.Error) && values.timestampList[index].ColumnName === initialValues.timestampList[index].ColumnName && _.trim((_c = values.dataContractErrorDetails) == null ? void 0 : _c.TimeStamp[index].Error) !== errorDuplicateSpecialColumn) {
        error.ColumnName = (_d = values.dataContractErrorDetails) == null ? void 0 : _d.TimeStamp[index].Error;
      }
      if (_.isEmpty(timestamp.ColumnName)) {
        error.ColumnName = "Column name must not be empty.";
      }
      if (timestamp.ColumnName && dict[timestamp.ColumnName] && dict[timestamp.ColumnName] >= 2) {
        error.ColumnName = errorDuplicateSpecialColumn;
      }
      hasErrors = !_.isEmpty(error) ? true : hasErrors;
      return error;
    });
    if (hasErrors && !!timestampListErrors) {
      existingErrors = __spreadProps(__spreadValues({}, existingErrors), {
        timestampList: timestampListErrors
      });
    }
  } else {
    existingErrors.timestampList = "Must create at least one timestamp column";
  }
  return existingErrors;
};
const validateParameterInfo = (values, existingErrors) => {
  if (values.parameterList && values.parameterList.length > 0) {
    _.each(values.parameterList, (item, key) => {
      if (item["required"]) {
        _.each(item["required"], (subItem) => {
          if (subItem !== "") {
            existingErrors.parameterList = "Required";
          }
        });
      }
    });
  }
  return existingErrors;
};
const validateAvailabilityStreamInfo = (values, existingErrors) => {
  if (values.streamList && values.streamList.length > 0) {
    _.each(values.streamList, (item, key) => {
      if (item["required"]) {
        _.each(item["required"], (subItem) => {
          if (subItem.length > 0) {
            existingErrors.streamList = "Required";
          }
        });
      }
    });
  }
  return existingErrors;
};
const GetRandomizationListTouched = (items) => {
  const result = _.map(items, (item) => {
    return {
      ColumnName: true,
      NGPColumnTag: true
    };
  });
  return result;
};
const GetFlightListTouched = (items) => {
  const result = _.map(items, (item) => {
    return {
      ColumnName: true,
      Format: true
    };
  });
  return result;
};
const GetTimestampListTouched = (items) => {
  const result = _.map(items, (item) => {
    return {
      ColumnName: true
    };
  });
  return result;
};
const getProfileJobConfigurationFrequency = (option) => {
  switch (option) {
    case ProfilingOptions.Weekly:
      return "168.00:00:00";
    case ProfilingOptions.Daily:
      return "24.00:00:00";
    case ProfilingOptions.Manual:
    default:
      return null;
  }
};
const getProfileJobConfigurationFrequencyFriendlyName = (option) => {
  switch (option) {
    case "168.00:00:00":
      return ProfilingOptions.Weekly;
    case "24.00:00:00":
      return ProfilingOptions.Daily;
    default:
      return ProfilingOptions.Manual;
  }
};
const showNGPColumnsInSpecialColumn = (storageType) => {
  return storageType === "Cosmos" || storageType === "ADLSGen2CosmosView";
};
const showMSIOption = (workspaceId) => {
  return EnvironmentService.enableMSIForDSMS() && !isClassicWorkspaceById(workspaceId);
};
export {
  getCosmosViewStartEndDefaultValue as $,
  AvailabilityStreamInfoComponent$1 as A,
  BasicInfoComponent$1 as B,
  CosomosViewDefaultDate as C,
  DataLocationInfoComponent as D,
  dataSourceCreateComponentsName as E,
  genErrorMessageOverrideDataSourceName as F,
  GetRandomizationListTouched as G,
  getValidateMessage as H,
  BasicInfoComponent as I,
  DataLocationAuthtencationFileds as J,
  ParametersInfoComponent as K,
  DataPathField as L,
  AvailabilityStreamInfoComponent as M,
  CreateStepKey as N,
  CreateStepTitle as O,
  ProfilingOptions as P,
  tabOrder as Q,
  DataProfilingComponent as R,
  SpecialColumnsComponent as S,
  getValidateCosmosDateTimeDiff as T,
  validateCluster as U,
  validateParameter as V,
  DataType as W,
  StorageType as X,
  FileFormat as Y,
  dataSourceDataTypeList as Z,
  sampleDataSourceDataTypeList as _,
  genErrorMessageAvailabilityStreamInfo as a,
  validateParameterInfo as b,
  validateAvailabilityStreamInfo as c,
  getDataSourceTypeLocation as d,
  getFileFormat as e,
  getProfileJobConfigurationFrequency as f,
  genErrorMessageParameterInfo as g,
  validateBasicInfo as h,
  validateDataLocationInfo as i,
  validateSpecialColumnsInfo as j,
  genErrorMessageDataLocationInfo as k,
  getCosmosViewDefaultParameter as l,
  getProfileJobConfigurationFrequencyFriendlyName as m,
  genErrorMessageDataSourceName as n,
  GetFlightListTouched as o,
  GetTimestampListTouched as p,
  ParametersInfoComponent$1 as q,
  DataProfilingComponent$1 as r,
  DataLinkInfoComponent as s,
  createStepProperties as t,
  showMSIOption as u,
  validateOverrideBasicInfo as v,
  CosmosViewDefaultDatePlaceholder as w,
  showNGPColumnsInSpecialColumn as x,
  DataProfilingChoiceGroupComponent as y,
  getPlaceHolder as z
};
//# sourceMappingURL=DataSourceFormikSettingsUtils-7b059167.js.map
